<header class="kt-header fixed top-0 z-10 start-0 end-0 flex items-stretch shrink-0 bg-background" data-kt-sticky="true" data-kt-sticky-class="border-b border-border" data-kt-sticky-name="header" id="header">
	<!-- begin: container -->
	<div class="kt-container-fixed flex justify-between items-stretch lg:gap-4" id="headerContainer">
		<!-- Mobile Logo -->
		<div class="flex gap-2.5 lg:hidden items-center -ms-1">
			<a class="shrink-0" href="#">
				<img class="max-h-[25px] w-full" src="assets/media/app/mini-logo.svg" />
			</a>
			<div class="flex items-center">
				<button class="kt-btn kt-btn-icon kt-btn-ghost" data-kt-drawer-toggle="#sidebar">
					<i class="ki-filled ki-menu">
					</i>
				</button>
				<button class="kt-btn kt-btn-icon kt-btn-ghost" data-kt-drawer-toggle="#mega_menu_wrapper">
					<i class="ki-filled ki-burger-menu-2">
					</i>
				</button>
			</div>
		</div>
		<!-- End of Mobile Logo -->
		<!--Megamenu Contaoner-->
		<div class="flex items-stretch" id="megaMenuContainer">
			<!--Megamenu Inner-->
			<div class="flex items-stretch [--kt-reparent-mode:prepend] [--kt-reparent-target:body] lg:[--kt-reparent-target:#megaMenuContainer] lg:[--kt-reparent-mode:prepend]"
				data-kt-reparent="true">
				<!--Megamenu Wrapper-->
				<div class="hidden lg:flex lg:items-stretch [--kt-drawer-enable:true] lg:[--kt-drawer-enable:false]"
					data-kt-drawer="true"
					data-kt-drawer-class="kt-drawer kt-drawer-start fixed z-10 top-0 bottom-0 w-full me-5 max-w-[250px] p-5 lg:p-0 overflow-auto"
					id="mega_menu_wrapper">
					<!--Megamenu-->
					<div class="kt-menu flex-col lg:flex-row gap-5 lg:gap-7.5" data-kt-menu="true" id="mega_menu">
						<!--Megamenu Item-->
						<div class="kt-menu-item active">
							<a class="kt-menu-link text-nowrap text-sm text-foreground font-medium kt-menu-item-hover:text-primary kt-menu-item-active:text-mono kt-menu-item-active:font-medium"
								href="#">
								<span class="kt-menu-title text-nowrap">
									Home
								</span>
							</a>
						</div>
						<!--End of Megamenu Item-->
						<!--Megamenu Item-->
						<div class="kt-menu-item" data-kt-menu-item-placement="bottom-start"
							data-kt-menu-item-placement-rtl="bottom-end"
							data-kt-menu-item-toggle="accordion|lg:dropdown" data-kt-menu-item-trigger="click|lg:hover">
							<div
								class="kt-menu-link text-sm text-foreground kt-menu-link-hover:text-primary kt-menu-item-active:text-mono kt-menu-item-show:text-primary kt-menu-item-here:text-mono kt-menu-item-active:font-medium kt-menu-item-here:font-medium">
								<span class="kt-menu-title text-nowrap">
									Profiles
								</span>
								<span class="kt-menu-arrow flex lg:hidden">
									<span class="kt-menu-item-show:hidden text-muted-foreground">
										<i class="ki-filled ki-plus text-xs">
										</i>
									</span>
									<span class="hidden kt-menu-item-show:inline-flex">
										<i class="ki-filled ki-minus text-xs">
										</i>
									</span>
								</span>
							</div>
							<div class="kt-menu-dropdown w-full gap-0 lg:max-w-[900px]">
								<div class="pt-4 pb-2 lg:p-7.5">
									<div class="grid lg:grid-cols-2 gap-5 lg:gap-10">
										<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
											<h3
												class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-5">
												Profiles
											</h3>
											<div class="grid lg:grid-cols-2 lg:gap-5">
												<div class="flex flex-col gap-0.5">
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-badge">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Default
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-coffee">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Creator
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-abstract-41">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Company
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-bitcoin">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																NFT
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-message-text">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Blogger
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-devices">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																CRM
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-ghost">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Gamer
															</span>
														</a>
													</div>
												</div>
												<div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-book">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Feeds
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-files">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Plain
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-mouse-square">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Modal
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link" href="#" tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-financial-schedule">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Freelancer
															</span>
															<span class="kt-menu-badge">
																<span class="kt-badge kt-badge-sm">
																	Soon
																</span>
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link" href="#" tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-technology-4">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Developer
															</span>
															<span class="kt-menu-badge">
																<span class="kt-badge kt-badge-sm">
																	Soon
																</span>
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link" href="#" tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-users">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Team
															</span>
															<span class="kt-menu-badge">
																<span class="kt-badge kt-badge-sm">
																	Soon
																</span>
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link" href="#" tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-calendar-tick">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Events
															</span>
															<span class="kt-menu-badge">
																<span class="kt-badge kt-badge-sm">
																	Soon
																</span>
															</span>
														</a>
													</div>
												</div>
											</div>
										</div>
										<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
											<h3
												class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-5">
												Other Pages
											</h3>
											<div class="grid lg:grid-cols-2 lg:gap-5">
												<div class="flex flex-col gap-0.5">
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-element-6">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Projects - 3 Columns
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-element-4">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Projects - 2 Columns
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#" tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-office-bag">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Works
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#" tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-people">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Teams
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#" tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-icon">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Network
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#" tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-chart-line-up-2">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Activity
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-element-11">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Campaigns - Card
															</span>
														</a>
													</div>
												</div>
												<div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-kanban">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Campaigns - List
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#" tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-file-sheet">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Empty Page
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link" href="#" tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-document">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Documents
															</span>
															<span class="kt-menu-badge">
																<span class="kt-badge kt-badge-sm">
																	Soon
																</span>
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link" href="#" tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-award">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Badges
															</span>
															<span class="kt-menu-badge">
																<span class="kt-badge kt-badge-sm">
																	Soon
																</span>
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link" href="#" tabindex="0">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-gift">
																</i>
															</span>
															<span class="kt-menu-title grow-0">
																Awards
															</span>
															<span class="kt-menu-badge">
																<span class="kt-badge kt-badge-sm">
																	Soon
																</span>
															</span>
														</a>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div
									class="flex flex-wrap items-center lg:justify-between rounded-xl lg:rounded-t-none border border-border lg:border-0 lg:border-t lg:border-t-border px-4 py-4 lg:px-7.5 lg:py-5 gap-2.5 bg-muted/50">
									<div class="flex flex-col gap-1.5">
										<div class="text-base font-semibold text-mono leading-none">
											Read to Get Started ?
										</div>
										<div class="text-sm fomt-medium text-secondary-foreground">
											Take your docs to the next level of Metronic
										</div>
									</div>
									<a class="kt-btn kt-btn-mono" href="#">
										Read Documentation
									</a>
								</div>
							</div>
						</div>
						<!--End of Megamenu Item-->
						<!--Megamenu Item-->
						<div class="kt-menu-item" data-kt-menu-item-offset="-300px, 0"
							data-kt-menu-item-offset-rtl="300px, 0" data-kt-menu-item-overflow="true"
							data-kt-menu-item-placement="bottom-start" data-kt-menu-item-placement-rtl="bottom-end"
							data-kt-menu-item-toggle="accordion|lg:dropdown" data-kt-menu-item-trigger="click|lg:hover">
							<div
								class="kt-menu-link text-sm text-secondary-foreground font-medium kt-menu-link-hover:text-primary kt-menu-item-active:text-mono kt-menu-item-show:text-primary kt-menu-item-here:text-mono kt-menu-item-active:font-semibold kt-menu-item-here:font-semibold">
								<span class="kt-menu-title text-nowrap">
									My Account
								</span>
								<span class="kt-menu-arrow flex lg:hidden">
									<span class="kt-menu-item-show:hidden text-muted-foreground">
										<i class="ki-filled ki-plus text-xs">
										</i>
									</span>
									<span class="hidden kt-menu-item-show:inline-flex">
										<i class="ki-filled ki-minus text-xs">
										</i>
									</span>
								</span>
							</div>
							<div class="kt-menu-dropdown flex-col lg:flex-row gap-0 w-full lg:max-w-[1240px]">
								<div
									class="lg:w-[250px] mt-2 lg:mt-0 lg:border-e lg:border-e-border rounded-xl lg:rounded-l-xl lg:rounded-r-none shrink-0 px-3 py-4 lg:p-7.5 bg-muted/25">
									<h3 class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-5">
										General Pages
									</h3>
									<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
										<div class="kt-menu-item">
											<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
												href="#">
												<span class="kt-menu-icon">
													<i class="ki-filled ki-technology-2">
													</i>
												</span>
												<span class="kt-menu-title grow-0">
													Integrations
												</span>
											</a>
										</div>
										<div class="kt-menu-item">
											<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
												href="#">
												<span class="kt-menu-icon">
													<i class="ki-filled ki-notification-1">
													</i>
												</span>
												<span class="kt-menu-title grow-0">
													Notifications
												</span>
											</a>
										</div>
										<div class="kt-menu-item">
											<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
												href="#">
												<span class="kt-menu-icon">
													<i class="ki-filled ki-key">
													</i>
												</span>
												<span class="kt-menu-title grow-0">
													API Keys
												</span>
											</a>
										</div>
										<div class="kt-menu-item">
											<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
												href="#">
												<span class="kt-menu-icon">
													<i class="ki-filled ki-eye">
													</i>
												</span>
												<span class="kt-menu-title grow-0">
													Appearance
												</span>
											</a>
										</div>
										<div class="kt-menu-item">
											<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
												href="#">
												<span class="kt-menu-icon">
													<i class="ki-filled ki-user-tick">
													</i>
												</span>
												<span class="kt-menu-title grow-0">
													Invite a Friend
												</span>
											</a>
										</div>
										<div class="kt-menu-item">
											<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
												href="#">
												<span class="kt-menu-icon">
													<i class="ki-filled ki-support">
													</i>
												</span>
												<span class="kt-menu-title grow-0">
													Activity
												</span>
											</a>
										</div>
										<div class="kt-menu-item">
											<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
												href="">
												<span class="kt-menu-icon">
													<i class="ki-filled ki-verify">
													</i>
												</span>
												<span class="kt-menu-title grow-0">
													Brand
												</span>
												<span class="kt-menu-badge">
													<span class="kt-badge kt-badge-sm">
														Soon
													</span>
												</span>
											</a>
										</div>
										<div class="kt-menu-item">
											<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
												href="">
												<span class="kt-menu-icon">
													<i class="ki-filled ki-euro">
													</i>
												</span>
												<span class="kt-menu-title grow-0">
													Get Paid
												</span>
												<span class="kt-menu-badge">
													<span class="kt-badge kt-badge-sm">
														Soon
													</span>
												</span>
											</a>
										</div>
									</div>
								</div>
								<div class="pt-4 pb-2 lg:p-7.5 lg:pb-5 grow">
									<div class="grid lg:grid-cols-5 gap-5">
										<div class="flex flex-col">
											<h3
												class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-5">
												Account Home
											</h3>
											<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#" tabindex="0">
														<span class="kt-menu-title grow-0">
															Get Started
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#" tabindex="0">
														<span class="kt-menu-title grow-0">
															User Profile
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															Company Profile
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															With Sidebar
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															Enterprise
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#" tabindex="0">
														<span class="kt-menu-title grow-0">
															Plain
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#" tabindex="0">
														<span class="kt-menu-title grow-0">
															Modal
														</span>
													</a>
												</div>
											</div>
										</div>
										<div class="flex flex-col">
											<h3
												class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-5">
												Billing
											</h3>
											<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
												<div class="kt-menu-item">
													<a class="kt-menu-link" href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															Basic Billing
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#" tabindex="0">
														<span class="kt-menu-title grow-0">
															Enterprise
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link" href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															Plans
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#" tabindex="0">
														<span class="kt-menu-title grow-0">
															Billing History
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link" href="" tabindex="0">
														<span class="kt-menu-title grow-0">
															Tax Info
														</span>
														<span class="kt-menu-badge">
															<span class="kt-badge kt-badge-sm">
																Soon
															</span>
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link" href="" tabindex="0">
														<span class="kt-menu-title grow-0">
															Invoices
														</span>
														<span class="kt-menu-badge">
															<span class="kt-badge kt-badge-sm">
																Soon
															</span>
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link" href="" tabindex="0">
														<span class="kt-menu-title grow-0">
															Gateaways
														</span>
														<span class="kt-menu-badge">
															<span class="kt-badge kt-badge-sm">
																Soon
															</span>
														</span>
													</a>
												</div>
											</div>
										</div>
										<div class="flex flex-col">
											<h3
												class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-5">
												Security
											</h3>
											<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															Get Started
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#" tabindex="0">
														<span class="kt-menu-title grow-0">
															Security Overview
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															IP Addresses
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															Privacy Settings
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															Device Management
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															Backup & Recovery
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															Current Sessions
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															Security Log
														</span>
													</a>
												</div>
											</div>
										</div>
										<div class="flex flex-col">
											<h3
												class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-5">
												Members & Roles
											</h3>
											<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															Teams Starter
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link" href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															Teams
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#" tabindex="0">
														<span class="kt-menu-title grow-0">
															Team Info
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															Members Starter
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															Team Members
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															Import Members
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link" href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															Roles
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															Persmissions - Toggler
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															Persmissions - Check
														</span>
													</a>
												</div>
											</div>
										</div>
										<div class="flex flex-col">
											<h3
												class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-5">
												Other Pages
											</h3>
											<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
												<div class="kt-menu-item">
													<a class="kt-menu-link" href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															Integrations
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link" href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															Notifications
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link" href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															API Keys
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link" href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															Appearance
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#" tabindex="0">
														<span class="kt-menu-title grow-0">
															Invite a Friend
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link" href="#"
														tabindex="0">
														<span class="kt-menu-title grow-0">
															Activity
														</span>
													</a>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!--End of Megamenu Item-->
						<!--Megamenu Item-->
						<div class="kt-menu-item" data-kt-menu-item-offset="-300px, 0"
							data-kt-menu-item-offset-rtl="300px, 0" data-kt-menu-item-overflow="true"
							data-kt-menu-item-placement="bottom-start" data-kt-menu-item-placement-rtl="bottom-end"
							data-kt-menu-item-toggle="accordion|lg:dropdown" data-kt-menu-item-trigger="click|lg:hover">
							<div
								class="kt-menu-link text-sm text-secondary-foreground font-medium kt-menu-link-hover:text-primary kt-menu-item-active:text-mono kt-menu-item-show:text-primary kt-menu-item-here:text-mono kt-menu-item-active:font-semibold kt-menu-item-here:font-semibold">
								<span class="kt-menu-title text-nowrap">
									Network
								</span>
								<span class="kt-menu-arrow flex lg:hidden">
									<span class="kt-menu-item-show:hidden text-muted-foreground">
										<i class="ki-filled ki-plus text-xs">
										</i>
									</span>
									<span class="hidden kt-menu-item-show:inline-flex">
										<i class="ki-filled ki-minus text-xs">
										</i>
									</span>
								</span>
							</div>
							<div class="kt-menu-dropdown flex-col gap-0 w-full lg:max-w-[670px]">
								<div class="flex flex-col lg:flex-row">
									<div
										class="flex flex-col gap-5 lg:w-[250px] mt-2 lg:mt-0 lg:border-r lg:border-r-border rounded-xl lg:rounded-none lg:rounded-tl-xl shrink-0 px-3 py-4 lg:p-7.5 bg-muted/25">
										<h3 class="text-sm text-foreground font-semibold leading-none ps-2.5 h-3.5">
											General Pages
										</h3>
										<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
											<div class="kt-menu-item">
												<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
													href="#">
													<span class="kt-menu-icon">
														<i class="ki-filled ki-flag">
														</i>
													</span>
													<span class="kt-menu-title grow-0">
														Get Started
													</span>
												</a>
											</div>
											<div class="kt-menu-item">
												<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
													href="#">
													<span class="kt-menu-icon">
														<i class="ki-filled ki-users">
														</i>
													</span>
													<span class="kt-menu-title grow-0">
														Colleagues
													</span>
													<span class="kt-menu-badge">
														<span class="kt-badge kt-badge-sm">
															Soon
														</span>
													</span>
												</a>
											</div>
											<div class="kt-menu-item">
												<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
													href="#">
													<span class="kt-menu-icon">
														<i class="ki-filled ki-heart">
														</i>
													</span>
													<span class="kt-menu-title grow-0">
														Donators
													</span>
													<span class="kt-menu-badge">
														<span class="kt-badge kt-badge-sm">
															Soon
														</span>
													</span>
												</a>
											</div>
											<div class="kt-menu-item">
												<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
													href="#">
													<span class="kt-menu-icon">
														<i class="ki-filled ki-abstract-21">
														</i>
													</span>
													<span class="kt-menu-title grow-0">
														Leads
													</span>
													<span class="kt-menu-badge">
														<span class="kt-badge kt-badge-sm">
															Soon
														</span>
													</span>
												</a>
											</div>
										</div>
									</div>
									<div class="pt-4 pb-2 lg:p-7.5 lg:pb-5 grow">
										<div class="grid lg:grid-cols-2 gap-5">
											<div class="flex flex-col gap-5">
												<h3
													class="flex items-center gap-1.5 text-sm text-foreground font-semibold leading-none ps-2.5 h-3.5">
													User Cards
												</h3>
												<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																Mini Cards
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																Team Crew
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#" tabindex="0">
															<span class="kt-menu-title grow-0">
																Authors
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																NFT Users
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link" href="#" tabindex="0">
															<span class="kt-menu-title grow-0">
																Social Users
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link" href="#" tabindex="0">
															<span class="kt-menu-title grow-0">
																Gamers
															</span>
															<span class="kt-menu-badge">
																<span class="kt-badge kt-badge-sm">
																	Soon
																</span>
															</span>
														</a>
													</div>
												</div>
											</div>
											<div class="flex flex-col gap-5">
												<h3
													class="flex items-center gap-1.5 text-sm text-foreground font-semibold leading-none ps-2.5 h-3.5">
													User Base
													<span
														class="left-auto kt-badge kt-badge-sm kt-badge-primary kt-badge-outline">
														Datatables
													</span>
												</h3>
												<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																Team Crew
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																App Roster
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																Market Authors
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																SaaS Users
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																Store Clients
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																Visitors
															</span>
														</a>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div
									class="flex flex-wrap items-center lg:justify-between rounded-xl lg:rounded-t-none border border-border lg:border-0 lg:border-t lg:border-t-border px-4 py-4 lg:px-7.5 lg:py-5 gap-2.5 bg-muted/50">
									<div class="flex flex-col gap-1.5">
										<div class="text-base font-semibold text-mono leading-none">
											Read to Get Started ?
										</div>
										<div class="text-sm fomt-medium text-secondary-foreground">
											Take your docs to the next level of Metronic
										</div>
									</div>
									<a class="kt-btn kt-btn-mono" href="#">
										Read Documentation
									</a>
								</div>
							</div>
						</div>
						<!--End of Megamenu Item-->
						<!--Megamenu Item-->
						<div class="kt-menu-item" data-kt-menu-item-offset="-300px, 0"
							data-kt-menu-item-offset-rtl="300px, 0" data-kt-menu-item-overflow="true"
							data-kt-menu-item-placement="bottom-start" data-kt-menu-item-placement-rtl="bottom-end"
							data-kt-menu-item-toggle="accordion|lg:dropdown" data-kt-menu-item-trigger="click|lg:hover">
							<div
								class="kt-menu-link text-sm text-secondary-foreground font-medium kt-menu-link-hover:text-primary kt-menu-item-active:text-mono kt-menu-item-show:text-primary kt-menu-item-here:text-mono kt-menu-item-active:font-semibold kt-menu-item-here:font-semibold">
								<span class="kt-menu-title text-nowrap">
									Store
								</span>
								<span class="kt-menu-arrow flex lg:hidden">
									<span class="kt-menu-item-show:hidden text-muted-foreground">
										<i class="ki-filled ki-plus text-xs">
										</i>
									</span>
									<span class="hidden kt-menu-item-show:inline-flex">
										<i class="ki-filled ki-minus text-xs">
										</i>
									</span>
								</span>
							</div>
							<div class="kt-menu-dropdown w-full gap-0 lg:max-w-[600px]">
								<div class="pt-4 pb-2 lg:p-7.5">
									<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
										<h3
											class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-5">
											Store - Client
										</h3>
										<div class="grid lg:grid-cols-2 lg:gap-5">
											<div class="flex flex-col gap-0.5">
												<div class="kt-menu-item">
													<a class="kt-menu-link" href="#"
														tabindex="0">
														<span class="kt-menu-icon">
															<i class="ki-filled ki-home">
															</i>
														</span>
														<span class="kt-menu-title grow-0">
															Home
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-icon">
															<i class="ki-filled ki-grid">
															</i>
														</span>
														<span class="kt-menu-title grow-0">
															Search Results - Grid
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-icon">
															<i class="ki-filled ki-tablet-text-up">
															</i>
														</span>
														<span class="kt-menu-title grow-0">
															Search Results - List
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-icon">
															<i class="ki-filled ki-picture">
															</i>
														</span>
														<span class="kt-menu-title grow-0">
															Product Details
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#" tabindex="0">
														<span class="kt-menu-icon">
															<i class="ki-filled ki-handcart">
															</i>
														</span>
														<span class="kt-menu-title grow-0">
															Shopping Cart
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link" href="#"
														tabindex="0">
														<span class="kt-menu-icon">
															<i class="ki-filled ki-heart">
															</i>
														</span>
														<span class="kt-menu-title grow-0">
															Wishlist
														</span>
													</a>
												</div>
											</div>
											<div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-icon">
															<i class="ki-filled ki-subtitle">
															</i>
														</span>
														<span class="kt-menu-title grow-0">
															Checkout - Order Summary
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-icon">
															<i class="ki-filled ki-delivery">
															</i>
														</span>
														<span class="kt-menu-title grow-0">
															Checkout - Shipping Info
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-icon">
															<i class="ki-filled ki-wallet">
															</i>
														</span>
														<span class="kt-menu-title grow-0">
															Checkout - Payment Method
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#"
														tabindex="0">
														<span class="kt-menu-icon">
															<i class="ki-filled ki-check-circle">
															</i>
														</span>
														<span class="kt-menu-title grow-0">
															Checkout - Order Placed
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#" tabindex="0">
														<span class="kt-menu-icon">
															<i class="ki-filled ki-archive">
															</i>
														</span>
														<span class="kt-menu-title grow-0">
															My Orders
														</span>
													</a>
												</div>
												<div class="kt-menu-item">
													<a class="kt-menu-link"
														href="#" tabindex="0">
														<span class="kt-menu-icon">
															<i class="ki-filled ki-document">
															</i>
														</span>
														<span class="kt-menu-title grow-0">
															Order Receipt
														</span>
													</a>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div
									class="flex flex-wrap items-center lg:justify-between rounded-xl lg:rounded-t-none border border-border lg:border-0 lg:border-t lg:border-t-border px-4 py-4 lg:px-7.5 lg:py-5 gap-2.5 bg-muted/50">
									<div class="flex flex-col gap-1.5">
										<div class="text-base font-semibold text-mono leading-none">
											Read to Get Started ?
										</div>
										<div class="text-sm fomt-medium text-secondary-foreground">
											Take your docs to the next level of Metronic
										</div>
									</div>
									<a class="kt-btn kt-btn-mono" href="#">
										Read Documentation
									</a>
								</div>
							</div>
						</div>
						<!--End of Megamenu Item-->
						<!--Megamenu Item-->
						<div class="kt-menu-item" data-kt-menu-item-offset="-300px, 0"
							data-kt-menu-item-offset-rtl="300px, 0" data-kt-menu-item-overflow="true"
							data-kt-menu-item-placement="bottom-start" data-kt-menu-item-placement-rtl="bottom-end"
							data-kt-menu-item-toggle="accordion|lg:dropdown" data-kt-menu-item-trigger="click|lg:hover">
							<div
								class="kt-menu-link text-sm text-secondary-foreground font-medium kt-menu-link-hover:text-primary kt-menu-item-active:text-mono kt-menu-item-show:text-primary kt-menu-item-here:text-mono kt-menu-item-active:font-semibold kt-menu-item-here:font-semibold">
								<span class="kt-menu-title text-nowrap">
									Authentication
								</span>
								<span class="kt-menu-arrow flex lg:hidden">
									<span class="kt-menu-item-show:hidden text-muted-foreground">
										<i class="ki-filled ki-plus text-xs">
										</i>
									</span>
									<span class="hidden kt-menu-item-show:inline-flex">
										<i class="ki-filled ki-minus text-xs">
										</i>
									</span>
								</span>
							</div>
							<div class="kt-menu-dropdown flex-col gap-0 w-full lg:max-w-[700px]">
								<div class="flex flex-col lg:flex-row">
									<div class="pt-4 pb-2 lg:p-7.5 lg:pb-5 grow">
										<div class="grid lg:grid-cols-2 gap-5">
											<div class="flex flex-col">
												<h3
													class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-5">
													Classic Layout
												</h3>
												<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																Sign In
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																Sign Up
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																2FA
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																Check Email
															</span>
														</a>
													</div>
													<div class="kt-menu-item pt-1">
														<span
															class="text-secondary-foreground font-medium text-sm p-2.5">
															Reset Password
														</span>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																Enter Email
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																Check Email
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																Change Password
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																Password is Changed
															</span>
														</a>
													</div>
												</div>
											</div>
											<div class="flex flex-col">
												<h3
													class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-5">
													Branded Layout
												</h3>
												<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																Sign In
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																Sign Up
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																2FA
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																Check Email
															</span>
														</a>
													</div>
													<div class="kt-menu-item pt-1">
														<span
															class="text-secondary-foreground font-medium text-sm p-2.5">
															Reset Password
														</span>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																Enter Email
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																Check Email
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																Change Password
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#"
															tabindex="0">
															<span class="kt-menu-title grow-0">
																Password is Changed
															</span>
														</a>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div
										class="lg:w-[260px] mb-4 lg:mb-0 lg:border-s lg:border-s-border rounded-xl lg:rounded-e-xl lg:rounded-l-none shrink-0 px-3 py-4 lg:p-7.5 bg-muted/25">
										<h3 class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-5">
											Other Pages
										</h3>
										<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
											<div class="kt-menu-item">
												<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
													href="#">
													<span class="kt-menu-icon">
														<i class="ki-filled ki-like-2">
														</i>
													</span>
													<span class="kt-menu-title grow-0">
														Welcome Message
													</span>
												</a>
											</div>
											<div class="kt-menu-item">
												<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
													href="#">
													<span class="kt-menu-icon">
														<i class="ki-filled ki-shield-cross">
														</i>
													</span>
													<span class="kt-menu-title grow-0">
														Account Deactivated
													</span>
												</a>
											</div>
											<div class="kt-menu-item">
												<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
													href="#">
													<span class="kt-menu-icon">
														<i class="ki-filled ki-message-question">
														</i>
													</span>
													<span class="kt-menu-title grow-0">
														Error 404
													</span>
												</a>
											</div>
											<div class="kt-menu-item">
												<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
													href="#">
													<span class="kt-menu-icon">
														<i class="ki-filled ki-information">
														</i>
													</span>
													<span class="kt-menu-title grow-0">
														Error 500
													</span>
												</a>
											</div>
										</div>
									</div>
								</div>
								<div
									class="flex flex-wrap items-center lg:justify-between rounded-xl lg:rounded-t-none border border-border lg:border-0 lg:border-t lg:border-t-border px-4 py-4 lg:px-7.5 lg:py-5 gap-2.5 bg-muted/50">
									<div class="flex flex-col gap-1.5">
										<div class="text-base font-semibold text-mono leading-none">
											Read to Get Started ?
										</div>
										<div class="text-sm fomt-medium text-secondary-foreground">
											Take your docs to the next level of Metronic
										</div>
									</div>
									<a class="kt-btn kt-btn-mono" href="#">
										Read Documentation
									</a>
								</div>
							</div>
						</div>
						<!--End of Megamenu Item-->
						<!--Megamenu Item-->
						<div class="kt-menu-item" data-kt-menu-item-offset="0,0|lg:-20px, 0"
							data-kt-menu-item-offset-rtl="0,0|lg:20px, 0" data-kt-menu-item-overflow="true"
							data-kt-menu-item-placement="bottom-start" data-kt-menu-item-placement-rtl="bottom-end"
							data-kt-menu-item-toggle="dropdown" data-kt-menu-item-trigger="click|lg:hover">
							<div
								class="kt-menu-link text-sm text-secondary-foreground font-medium kt-menu-link-hover:text-primary kt-menu-item-active:text-mono kt-menu-item-show:text-primary kt-menu-item-here:text-mono kt-menu-item-active:font-semibold kt-menu-item-here:font-semibold">
								<span class="kt-menu-title text-nowrap">
									Help
								</span>
								<span class="kt-menu-arrow flex lg:hidden">
									<span class="kt-menu-item-show:hidden text-muted-foreground">
										<i class="ki-filled ki-plus text-xs">
										</i>
									</span>
									<span class="hidden kt-menu-item-show:inline-flex">
										<i class="ki-filled ki-minus text-xs">
										</i>
									</span>
								</span>
							</div>
							<div class="kt-menu-dropdown kt-menu-default py-2.5 w-full max-w-[220px]">
								<div class="kt-menu-item">
									<a class="kt-menu-link"
										href="https://keenthemes.com/metronic/tailwind/docs/getting-started/installation"
										tabindex="0">
										<span class="kt-menu-icon">
											<i class="ki-filled ki-coffee">
											</i>
										</span>
										<span class="kt-menu-title grow-0">
											Getting Started
										</span>
									</a>
								</div>
								<div class="kt-menu-item" data-kt-menu-item-placement="right-start"
									data-kt-menu-item-placement-rtl="left-start" data-kt-menu-item-toggle="dropdown"
									data-kt-menu-item-trigger="click|lg:hover">
									<div class="kt-menu-link">
										<span class="kt-menu-icon">
											<i class="ki-filled ki-information">
											</i>
										</span>
										<span class="kt-menu-title">
											Support Forum
										</span>
										<span class="kt-menu-arrow">
											<i class="ki-filled ki-right text-xs rtl:transform rtl:rotate-180">
											</i>
										</span>
									</div>
									<div class="kt-menu-dropdown kt-menu-default w-full max-w-[175px] lg:max-w-[220px]">
										<div class="kt-menu-item">
											<a class="kt-menu-link" href="https://devs.keenthemes.com" tabindex="0">
												<span class="kt-menu-icon">
													<i class="ki-filled ki-questionnaire-tablet">
													</i>
												</span>
												<span class="kt-menu-title grow-0">
													All Questions
												</span>
											</a>
										</div>
										<div class="kt-menu-item">
											<a class="kt-menu-link" href="https://devs.keenthemes.com/popular"
												tabindex="0">
												<span class="kt-menu-icon">
													<i class="ki-filled ki-star">
													</i>
												</span>
												<span class="kt-menu-title grow-0">
													Popular Questions
												</span>
											</a>
										</div>
										<div class="kt-menu-item">
											<a class="kt-menu-link" href="https://devs.keenthemes.com/question/create"
												tabindex="0">
												<span class="kt-menu-icon">
													<i class="ki-filled ki-message-question">
													</i>
												</span>
												<span class="kt-menu-title grow-0">
													Ask Question
												</span>
											</a>
										</div>
									</div>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link"
										href="https://keenthemes.com/metronic/tailwind/docs/getting-started/license"
										tabindex="0">
										<span class="kt-menu-icon">
											<i class="ki-filled ki-subtitle">
											</i>
										</span>
										<span class="kt-menu-title">
											Licenses & FAQ
										</span>
										<span class="kt-menu-badge" data-kt-tooltip="#menu_tooltip_3">
											<i class="ki-filled ki-information-2 text-muted-foreground text-base">
											</i>
										</span>
										<div class="kt-tooltip" id="menu_tooltip_3">
											Learn more about licenses
										</div>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="https://keenthemes.com/metronic/tailwind/docs"
										tabindex="0">
										<span class="kt-menu-icon">
											<i class="ki-filled ki-questionnaire-tablet">
											</i>
										</span>
										<span class="kt-menu-title grow-0">
											Documentation
										</span>
									</a>
								</div>
								<div class="kt-menu-separator">
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="https://keenthemes.com/contact" tabindex="0">
										<span class="kt-menu-icon">
											<i class="ki-filled ki-share">
											</i>
										</span>
										<span class="kt-menu-title grow-0">
											Contact Us
										</span>
									</a>
								</div>
							</div>
						</div>
						<!--End of Megamenu Item-->
					</div>
					<!--End of Megamenu-->
				</div>
				<!--End of Megamenu Wrapper-->
			</div>
			<!--End of Megamenu Inner-->
		</div>
		<!--End of Megamenu Contaoner-->
		<!-- Topbar -->
		<div class="flex items-center gap-2.5">
			<!-- Search -->
			<button
				class="group kt-btn kt-btn-ghost kt-btn-icon size-9 rounded-full hover:bg-primary/10 hover:[&_i]:text-primary"
				data-kt-modal-toggle="#search_modal">
				<i class="ki-filled ki-magnifier text-lg group-hover:text-primary">
				</i>
			</button>
			<!-- End of Search -->
			<!-- Notifications -->
			<button
				class="kt-btn kt-btn-ghost kt-btn-icon size-9 rounded-full hover:bg-primary/10 hover:[&_i]:text-primary"
				data-kt-drawer-toggle="#notifications_drawer">
				<i class="ki-filled ki-notification-status text-lg">
				</i>
			</button>
			<!--Notifications Drawer-->
			<div class="hidden kt-drawer kt-drawer-end card flex-col max-w-[90%] w-[450px] top-5 bottom-5 end-5 rounded-xl border border-border"
				data-kt-drawer="true" data-kt-drawer-container="body" id="notifications_drawer">
				<div class="flex items-center justify-between gap-2.5 text-sm text-mono font-semibold px-5 py-2.5 border-b border-b-border"
					id="notifications_header">
					Notifications
					<button class="kt-btn kt-btn-sm kt-btn-icon kt-btn-dim shrink-0" data-kt-drawer-dismiss="true">
						<i class="ki-filled ki-cross">
						</i>
					</button>
				</div>
				<div class="kt-tabs kt-tabs-line justify-between px-5 mb-2" data-kt-tabs="true" id="notifications_tabs">
					<div class="flex items-center gap-5">
						<button class="kt-tab-toggle py-3 active" data-kt-tab-toggle="#notifications_tab_all">
							All
						</button>
						<button class="kt-tab-toggle py-3 relative" data-kt-tab-toggle="#notifications_tab_inbox">
							Inbox
							<span
								class="rounded-full bg-green-500 size-[5px] absolute top-2 rtl:start-0 end-0 transform translate-y-1/2 translate-x-full">
							</span>
						</button>
						<button class="kt-tab-toggle py-3" data-kt-tab-toggle="#notifications_tab_team">
							Team
						</button>
						<button class="kt-tab-toggle py-3" data-kt-tab-toggle="#notifications_tab_following">
							Following
						</button>
					</div>
					<div class="kt-menu" data-kt-menu="true">
						<div class="kt-menu-item" data-kt-menu-item-offset="0,10px"
							data-kt-menu-item-placement="bottom-end" data-kt-menu-item-placement-rtl="bottom-start"
							data-kt-menu-item-toggle="dropdown" data-kt-menu-item-trigger="click|lg:hover">
							<button class="kt-menu-toggle kt-btn kt-btn-icon kt-btn-ghost">
								<i class="ki-filled ki-setting-2">
								</i>
							</button>
							<div class="kt-menu-dropdown kt-menu-default w-full max-w-[175px]"
								data-kt-menu-dismiss="true">
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="#">
										<span class="kt-menu-icon">
											<i class="ki-filled ki-document">
											</i>
										</span>
										<span class="kt-menu-title">
											View
										</span>
									</a>
								</div>
								<div class="kt-menu-item" data-kt-menu-item-offset="-15px, 0"
									data-kt-menu-item-placement="right-start" data-kt-menu-item-toggle="dropdown"
									data-kt-menu-item-trigger="click|lg:hover">
									<div class="kt-menu-link">
										<span class="kt-menu-icon">
											<i class="ki-filled ki-notification-status">
											</i>
										</span>
										<span class="kt-menu-title">
											Export
										</span>
										<span class="kt-menu-arrow">
											<i class="ki-filled ki-right text-xs rtl:transform rtl:rotate-180">
											</i>
										</span>
									</div>
									<div class="kt-menu-dropdown kt-menu-default w-full max-w-[175px]">
										<div class="kt-menu-item">
											<a class="kt-menu-link"
												href="#">
												<span class="kt-menu-icon">
													<i class="ki-filled ki-sms">
													</i>
												</span>
												<span class="kt-menu-title">
													Email
												</span>
											</a>
										</div>
										<div class="kt-menu-item">
											<a class="kt-menu-link"
												href="#">
												<span class="kt-menu-icon">
													<i class="ki-filled ki-message-notify">
													</i>
												</span>
												<span class="kt-menu-title">
													SMS
												</span>
											</a>
										</div>
										<div class="kt-menu-item">
											<a class="kt-menu-link"
												href="#">
												<span class="kt-menu-icon">
													<i class="ki-filled ki-notification-status">
													</i>
												</span>
												<span class="kt-menu-title">
													Push
												</span>
											</a>
										</div>
									</div>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="#">
										<span class="kt-menu-icon">
											<i class="ki-filled ki-pencil">
											</i>
										</span>
										<span class="kt-menu-title">
											Edit
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="#">
										<span class="kt-menu-icon">
											<i class="ki-filled ki-trash">
											</i>
										</span>
										<span class="kt-menu-title">
											Delete
										</span>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="grow flex flex-col" id="notifications_tab_all">
					<div class="grow kt-scrollable-y-auto" data-kt-scrollable="true"
						data-kt-scrollable-dependencies="#header" data-kt-scrollable-max-height="auto"
						data-kt-scrollable-offset="150px">
						<div class="grow flex flex-col gap-5 pt-3 pb-4 divider-y divider-border">
							<div class="flex grow gap-2.5 px-5">
								<div class="kt-avatar size-8">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-4.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
								<div class="flex flex-col gap-3.5">
									<div class="flex flex-col gap-1">
										<div class="text-sm font-medium">
											<a class="hover:text-primary text-mono font-semibold" href="#">
												Joe Lincoln
											</a>
											<span class="text-secondary-foreground">
												mentioned you in
											</span>
											<a class="hover:text-primary text-primary" href="#">
												Latest Trends
											</a>
											<span class="text-secondary-foreground">
												topic
											</span>
										</div>
										<span class="flex items-center text-xs font-medium text-muted-foreground">
											18 mins ago
											<span class="rounded-full size-1 bg-mono/30 mx-1.5">
											</span>
											Web Design 2024
										</span>
									</div>
									<div class="kt-card shadow-none flex flex-col gap-2.5 p-3.5 rounded-lg bg-muted/70">
										<div class="text-sm font-semibold text-secondary-foreground mb-px">
											<a class="hover:text-primary text-mono font-semibold" href="#">
												&#64;Cody
											</a>
											<span class="text-secondary-foreground font-medium">
												For an expert opinion, check out what Mike has to say on this topic!
											</span>
										</div>
										<div class="kt-input">
											<input placeholder="Reply" type="text" value="" />
											<button class="kt-btn kt-btn-ghost kt-btn-icon size-6 -me-1.5">
												<i class="ki-filled ki-picture">
												</i>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div class="border-b border-b-border">
							</div>
							<div class="flex grow gap-2.5 px-5">
								<div class="kt-avatar size-8">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-5.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
								<div class="flex flex-col gap-3.5">
									<div class="flex flex-col gap-1">
										<div class="text-sm font-medium mb-px">
											<a class="hover:text-primary text-mono font-semibold" href="#">
												Leslie Alexander
											</a>
											<span class="text-secondary-foreground">
												added new tags to
											</span>
											<a class="hover:text-primary text-primary" href="#">
												Web Redesign 2024
											</a>
										</div>
										<span class="flex items-center text-xs font-medium text-muted-foreground">
											53 mins ago
											<span class="rounded-full size-1 bg-mono/30 mx-1.5">
											</span>
											ACME
										</span>
									</div>
									<div class="flex flex-wrap gap-2.5">
										<span class="kt-badge kt-badge-sm kt-badge-info kt-badge-outline">
											Client-Request
										</span>
										<span class="kt-badge kt-badge-sm kt-badge-warning kt-badge-outline">
											Figma
										</span>
										<span class="kt-badge kt-badge-sm kt-badge-secondary kt-badge-outline">
											Redesign
										</span>
									</div>
								</div>
							</div>
							<div class="border-b border-b-border">
							</div>
							<div class="flex grow gap-2.5 px-5" id="notification_request_3">
								<div class="kt-avatar size-8">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-27.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
								<div class="flex flex-col gap-3.5">
									<div class="flex flex-col gap-1">
										<div class="text-sm font-medium mb-px">
											<a class="hover:text-primary text-mono font-semibold" href="#">
												Guy Hawkins
											</a>
											<span class="text-secondary-foreground">
												requested access to
											</span>
											<a class="hover:text-primary text-primary" href="#">
												AirSpace
											</a>
											<span class="text-secondary-foreground">
												project
											</span>
										</div>
										<span class="flex items-center text-xs font-medium text-muted-foreground">
											14 hours ago
											<span class="rounded-full size-1 bg-mono/30 mx-1.5">
											</span>
											Dev Team
										</span>
									</div>
									<div class="flex flex-wrap gap-2.5">
										<button class="kt-btn kt-btn-outline kt-btn-sm"
											data-kt-dismiss="#notification_request_3">
											Decline
										</button>
										<button class="kt-btn kt-btn-mono kt-btn-sm"
											data-kt-dismiss="#notification_request_3">
											Accept
										</button>
									</div>
								</div>
							</div>
							<div class="border-b border-b-border">
							</div>
							<div class="flex grow gap-2.5 px-5">
								<div class="kt-avatar size-8">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-10.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-offline size-2.5">
										</div>
									</div>
								</div>
								<div class="flex flex-col gap-3.5 grow">
									<div class="flex flex-col gap-1">
										<div class="text-sm font-medium mb-px">
											<a class="hover:text-primary text-mono font-semibold" href="#">
												Jane Perez
											</a>
											<span class="text-secondary-foreground">
												invites you to review a file.
											</span>
										</div>
										<span class="flex items-center text-xs font-medium text-muted-foreground">
											3 hours ago
											<span class="rounded-full size-1 bg-mono/30 mx-1.5">
											</span>
											742kb
										</span>
									</div>
									<div
										class="kt-card shadow-none flex items-center flex-row gap-1.5 p-2.5 rounded-lg bg-muted/70">
										<img class="h-5" src="assets/media/file-types/pdf.svg" />
										<a class="hover:text-primary font-medium text-secondary-foreground text-xs me-1"
											href="#">
											Launch_nov24.pptx
										</a>
										<span class="font-medium text-muted-foreground text-xs">
											Edited 39 mins ago
										</span>
									</div>
								</div>
							</div>
							<div class="border-b border-b-border">
							</div>
							<div class="flex grow gap-2.5 px-5">
								<div class="kt-avatar size-8">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-11.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
								<div class="flex flex-col gap-1">
									<div class="text-sm font-medium mb-px">
										<a class="hover:text-primary text-mono font-semibold" href="#">
											Raymond Pawell
										</a>
										<span class="text-secondary-foreground">
											posted a new article
										</span>
										<a class="hover:text-primary text-primary" href="#">
											2024 Roadmap
										</a>
									</div>
									<span class="flex items-center text-xs font-medium text-muted-foreground">
										1 hour ago
										<span class="rounded-full size-1 bg-mono/30 mx-1.5">
										</span>
										Roadmap
									</span>
								</div>
							</div>
							<div class="border-b border-b-border">
							</div>
							<div class="flex grow gap-2.5 px-5">
								<div class="kt-avatar size-8">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-14.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-offline size-2.5">
										</div>
									</div>
								</div>
								<div class="flex flex-col gap-3.5 grow">
									<div class="flex flex-col gap-1">
										<div class="text-sm font-medium mb-px">
											<a class="hover:text-primary text-mono font-semibold" href="#">
												Tyler Hero
											</a>
											<span class="text-secondary-foreground">
												wants to view your design project
											</span>
										</div>
										<span class="flex items-center text-xs font-medium text-muted-foreground">
											3 day ago
											<span class="rounded-full size-1 bg-mono/30 mx-1.5">
											</span>
											Metronic Launcher mockups
										</span>
									</div>
									<div
										class="kt-card shadow-none flex items-center flex-row gap-1.5 p-2.5 rounded-lg bg-muted/70">
										<div
											class="flex items-center justify-center w-[26px] h-[30px] shrink-0 bg-background rounded-sm border border-border">
											<img class="h-5" src="assets/media/file-types/figma.svg" />
										</div>
										<a class="hover:text-primary font-medium text-secondary-foreground text-xs me-1"
											href="#">
											Launcher-UIkit.fig
										</a>
										<span class="font-medium text-muted-foreground text-xs">
											Edited 2 mins ago
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="border-b border-b-border">
					</div>
					<div class="grid grid-cols-2 p-5 gap-2.5" id="notifications_all_footer">
						<button class="kt-btn kt-btn-outline justify-center">
							Archive all
						</button>
						<button class="kt-btn kt-btn-outline justify-center">
							Mark all as read
						</button>
					</div>
				</div>
				<div class="grow flex flex-col hidden" id="notifications_tab_inbox">
					<div class="grow kt-scrollable-y-auto" data-kt-scrollable="true"
						data-kt-scrollable-dependencies="#header" data-kt-scrollable-max-height="auto"
						data-kt-scrollable-offset="150px">
						<div class="flex flex-col gap-5 pt-3 pb-4">
							<div class="flex grow gap-2.5 px-5" id="notification_request_13">
								<div class="kt-avatar size-8">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-25.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
								<div class="flex flex-col gap-3.5 grow">
									<div class="flex flex-col gap-1">
										<div class="text-sm font-medium mb-px">
											<a class="hover:text-primary text-mono font-semibold" href="#">
												Samuel Lee
											</a>
											<span class="text-secondary-foreground">
												requested to add user to
											</span>
											<a class="hover:text-primary text-primary font-semibold" href="#">
												TechSynergy
											</a>
										</div>
										<span class="flex items-center text-xs font-medium text-muted-foreground">
											22 hours ago
											<span class="rounded-full size-1 bg-mono/30 mx-1.5">
											</span>
											Dev Team
										</span>
									</div>
									<div
										class="kt-card shadow-none flex items-center flex-row justify-between gap-1.5 px-2.5 py-2 rounded-lg bg-muted/70">
										<div class="flex flex-col">
											<a class="hover:text-primary font-medium text-mono text-xs" href="#">
												Ronald Richards
											</a>
											<a class="hover:text-primary text-muted-foreground font-medium text-xs"
												href="#">
												ronald.richards&#64;gmail.com
											</a>
										</div>
										<a class="hover:text-primary text-secondary-foreground font-medium text-xs"
											href="#">
											Go to profile
										</a>
									</div>
									<div class="flex flex-wrap gap-2.5">
										<button class="kt-btn kt-btn-outline kt-btn-sm"
											data-kt-dismiss="#notification_request_13">
											Decline
										</button>
										<button class="kt-btn kt-btn-mono kt-btn-sm"
											data-kt-dismiss="#notification_request_13">
											Accept
										</button>
									</div>
								</div>
							</div>
							<div class="border-b border-b-border">
							</div>
							<div class="flex items-center grow gap-2.5 px-5">
								<div
									class="flex items-center justify-center size-8 bg-green-50 rounded-full border border-green-200 dark:border-green-950">
									<i class="ki-filled ki-check text-lg text-green-500">
									</i>
								</div>
								<div class="flex flex-col gap-1">
									<span class="text-sm font-medium text-secondary-foreground">
										You have succesfully verified your account
									</span>
									<span class="font-medium text-muted-foreground text-xs">
										2 days ago
									</span>
								</div>
							</div>
							<div class="border-b border-b-border">
							</div>
							<div class="flex grow gap-2.5 px-5">
								<div class="kt-avatar size-8">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-34.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
								<div class="flex flex-col gap-3.5 grow">
									<div class="flex flex-col gap-1">
										<div class="text-sm font-medium mb-px">
											<a class="hover:text-primary text-mono font-semibold" href="#">
												Ava Peterson
											</a>
											<span class="text-secondary-foreground">
												uploaded attachment
											</span>
										</div>
										<span class="flex items-center text-xs font-medium text-muted-foreground">
											3 days ago
											<span class="rounded-full size-1 bg-mono/30 mx-1.5">
											</span>
											ACME
										</span>
									</div>
									<div
										class="kt-card shadow-none flex items-center justify-between flex-row gap-1.5 p-2.5 rounded-lg bg-muted/70">
										<div class="flex items-center gap-1.5">
											<img class="h-6" src="assets/media/file-types/xls.svg" />
											<div class="flex flex-col gap-0.5">
												<a class="hover:text-primary font-medium text-secondary-foreground text-xs"
													href="#">
													Redesign-2024.xls
												</a>
												<span class="font-medium text-muted-foreground text-xs">
													2.6 MB
												</span>
											</div>
										</div>
										<button class="kt-btn kt-btn-sm kt-btn-icon kt-btn-ghost">
											<svg fill="none" height="14" viewbox="0 0 14 14" width="14"
												xmlns="http://www.w3.org/2000/svg">
												<path clip-rule="evenodd"
													d="M6.63821 2.60467C4.81926 2.60467 3.32474 3.99623 3.16201 5.77252C3.1386 6.02803 2.92413 6.22253 2.66871 6.22227C1.74915 6.22149 0.976744 6.9868 0.976744 7.90442C0.976744 8.83344 1.72988 9.58657 2.65891 9.58657H3.09302C3.36274 9.58657 3.5814 9.80523 3.5814 10.0749C3.5814 10.3447 3.36274 10.5633 3.09302 10.5633H2.65891C1.19044 10.5633 0 9.37292 0 7.90442C0 6.58614 0.986948 5.48438 2.24496 5.27965C2.62863 3.20165 4.44941 1.62793 6.63821 1.62793C8.26781 1.62793 9.69282 2.50042 10.4729 3.80193C12.3411 3.72829 14 5.2564 14 7.18091C14 8.93508 12.665 10.3769 10.9552 10.5466C10.6868 10.5733 10.4476 10.3773 10.421 10.1089C10.3943 9.84052 10.5903 9.60135 10.8587 9.57465C12.0739 9.45406 13.0233 8.42802 13.0233 7.18091C13.0233 5.74002 11.6905 4.59666 10.2728 4.79968C10.0642 4.82957 9.85672 4.72382 9.76028 4.53181C9.18608 3.38796 8.00318 2.60467 6.63821 2.60467Z"
													fill="#99A1B7" fill-rule="evenodd">
												</path>
												<path clip-rule="evenodd"
													d="M6.99909 8.01611L8.28162 9.29864C8.47235 9.48937 8.78158 9.48937 8.97231 9.29864C9.16303 9.10792 9.16303 8.79874 8.97231 8.60802L7.57465 7.2103C7.25675 6.89247 6.74143 6.89247 6.42353 7.2103L5.02585 8.60802C4.83513 8.79874 4.83513 9.10792 5.02585 9.29864C5.21657 9.48937 5.5258 9.48937 5.71649 9.29864L6.99909 8.01611Z"
													fill="#99A1B7" fill-rule="evenodd">
												</path>
												<path clip-rule="evenodd"
													d="M7.00009 12.372C7.2698 12.372 7.48846 12.1533 7.48846 11.8836V7.97665C7.48846 7.70694 7.2698 7.48828 7.00009 7.48828C6.73038 7.48828 6.51172 7.70694 6.51172 7.97665V11.8836C6.51172 12.1533 6.73038 12.372 7.00009 12.372Z"
													fill="#99A1B7" fill-rule="evenodd">
												</path>
											</svg>
										</button>
									</div>
								</div>
							</div>
							<div class="border-b border-b-border">
							</div>
							<div class="flex grow gap-2 px-5">
								<div class="kt-avatar size-8">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-29.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
								<div class="flex flex-col gap-3 grow">
									<div class="flex flex-col gap-1">
										<div class="text-sm font-medium mb-px">
											<a class="hover:text-primary text-mono font-semibold" href="#">
												Ethan Parker
											</a>
											<span class="text-secondary-foreground">
												created a new tasks to
											</span>
											<a class="hover:text-primary text-primary" href="#">
												Site Sculpt
											</a>
											<span class="text-secondary-foreground">
												project
											</span>
										</div>
										<span class="flex items-center text-xs font-medium text-muted-foreground">
											3 days ago
											<span class="rounded-full size-1 bg-mono/30 mx-1.5">
											</span>
											Web Designer
										</span>
									</div>
									<div class="kt-card shadow-none p-3.5 gap-3.5 rounded-lg bg-muted/70">
										<div class="flex items-center justify-between flex-wrap gap-2.5">
											<div class="flex flex-col gap-1">
												<span class="font-medium text-mono text-xs">
													Location history is erased after Logging In
												</span>
												<span class="font-medium text-muted-foreground text-xs">
													Due Date: 15 May, 2024
												</span>
											</div>
											<div class="flex -space-x-2">
												<div class="flex">
													<img class="hover:z-5 relative shrink-0 rounded-full ring-1 ring-background size-6"
														src="assets/media/avatars/300-3.png" />
												</div>
												<div class="flex">
													<img class="hover:z-5 relative shrink-0 rounded-full ring-1 ring-background size-6"
														src="assets/media/avatars/300-2.png" />
												</div>
											</div>
										</div>
										<div class="flex items-center gap-2.5">
											<span class="kt-badge kt-badge-sm kt-badge-success kt-badge-outline">
												Improvement
											</span>
											<span class="kt-badge kt-badge-sm kt-badge-destructive kt-badge-outline">
												Bug
											</span>
										</div>
									</div>
								</div>
							</div>
							<div class="border-b border-b-border">
							</div>
							<div class="flex grow gap-2.5 px-5" id="notification_request_3">
								<div class="kt-avatar size-8">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-30.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
								<div class="flex flex-col gap-3.5">
									<div class="flex flex-col gap-1">
										<div class="text-sm font-medium mb-px">
											<a class="hover:text-primary text-mono font-semibold" href="#">
												Benjamin Harris
											</a>
											<span class="text-secondary-foreground">
												requested to upgrade plan
											</span>
											<a class="hover:text-primary text-primary" href="#">
											</a>
											<span class="text-secondary-foreground">
											</span>
										</div>
										<span class="flex items-center text-xs font-medium text-muted-foreground">
											4 days ago
											<span class="rounded-full size-1 bg-mono/30 mx-1.5">
											</span>
											Marketing
										</span>
									</div>
									<div class="flex flex-wrap gap-2.5">
										<button class="kt-btn kt-btn-outline kt-btn-sm"
											data-kt-dismiss="#notification_request_3">
											Decline
										</button>
										<button class="kt-btn kt-btn-mono kt-btn-sm"
											data-kt-dismiss="#notification_request_3">
											Accept
										</button>
									</div>
								</div>
							</div>
							<div class="border-b border-b-border">
							</div>
							<div class="flex grow gap-2.5 px-5">
								<div class="kt-avatar size-8">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-24.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
								<div class="flex flex-col gap-1">
									<div class="text-sm font-medium mb-px">
										<a class="hover:text-primary text-mono font-semibold" href="#">
											Isaac Morgan
										</a>
										<span class="text-secondary-foreground">
											mentioned you in
										</span>
										<a class="hover:text-primary text-primary" href="#">
											Data Transmission
										</a>
										topic
									</div>
									<span class="flex items-center text-xs font-medium text-muted-foreground">
										6 days ago
										<span class="rounded-full size-1 bg-mono/30 mx-1.5">
										</span>
										Dev Team
									</span>
								</div>
							</div>
						</div>
					</div>
					<div class="border-b border-b-border">
					</div>
					<div class="grid grid-cols-2 p-5 gap-2.5" id="notifications_inbox_footer">
						<button class="kt-btn kt-btn-outline justify-center">
							Archive all
						</button>
						<button class="kt-btn kt-btn-outline justify-center">
							Mark all as read
						</button>
					</div>
				</div>
				<div class="grow flex flex-col hidden" id="notifications_tab_team">
					<div class="grow kt-scrollable-y-auto" data-kt-scrollable="true"
						data-kt-scrollable-dependencies="#header" data-kt-scrollable-max-height="auto"
						data-kt-scrollable-offset="150px">
						<div class="flex flex-col gap-5 pt-3 pb-4">
							<div class="flex grow gap-2 px-5">
								<div class="kt-avatar size-8">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-15.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
								<div class="flex flex-col gap-3 grow" id="notification_request_10">
									<div class="flex flex-col gap-1">
										<div class="text-sm font-medium mb-px">
											<a class="hover:text-primary text-mono font-semibold" href="#">
												Nova Hawthorne
											</a>
											<span class="text-secondary-foreground">
												sent you an meeting invation
											</span>
										</div>
										<span class="flex items-center text-xs font-medium text-muted-foreground">
											2 days ago
											<span class="rounded-full size-1 bg-mono/30 mx-1.5">
											</span>
											Dev Team
										</span>
									</div>
									<div class="kt-card shadow-none p-2.5 rounded-lg bg-muted/70">
										<div class="flex items-center justify-between flex-wrap gap-2.5">
											<div class="flex items-center gap-2.5">
												<div class="border border-primary/10 rounded-lg">
													<div
														class="flex items-center justify-center border-b border-b-primary/10 bg-primary/10 rounded-t-lg">
														<span class="text-xs text-primary fw-medium p-1.5">
															Apr
														</span>
													</div>
													<div class="flex items-center justify-center size-9">
														<span class="fw-semibold text-mono text-md tracking-tight">
															12
														</span>
													</div>
												</div>
												<div class="flex flex-col gap-1.5">
													<a class="hover:text-primary font-medium text-secondary-foreground text-xs"
														href="#">
														Peparation For Release
													</a>
													<span class="font-medium text-secondary-foreground text-xs">
														9:00 PM - 10:00 PM
													</span>
												</div>
											</div>
											<div class="flex -space-x-2">
												<div class="flex">
													<img class="hover:z-5 relative shrink-0 rounded-full ring-1 ring-background size-6"
														src="assets/media/avatars/300-4.png" />
												</div>
												<div class="flex">
													<img class="hover:z-5 relative shrink-0 rounded-full ring-1 ring-background size-6"
														src="assets/media/avatars/300-1.png" />
												</div>
												<div class="flex">
													<img class="hover:z-5 relative shrink-0 rounded-full ring-1 ring-background size-6"
														src="assets/media/avatars/300-2.png" />
												</div>
												<div class="flex">
													<span
														class="hover:z-5 relative inline-flex items-center justify-center shrink-0 rounded-full ring-1 font-semibold leading-none text-2xs size-6 text-white size-6 ring-background bg-green-500">
														+3
													</span>
												</div>
											</div>
										</div>
									</div>
									<div class="flex flex-wrap gap-2.5">
										<button class="kt-btn kt-btn-outline kt-btn-sm"
											data-kt-dismiss="#notification_request_10">
											Decline
										</button>
										<button class="kt-btn kt-btn-mono kt-btn-sm"
											data-kt-dismiss="#notification_request_10">
											Accept
										</button>
									</div>
								</div>
							</div>
							<div class="border-b border-b-border">
							</div>
							<div class="flex grow gap-2.5 px-5">
								<div class="kt-avatar size-8">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-6.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
								<div class="flex flex-col gap-1">
									<div class="text-sm font-medium mb-px">
										<a class="hover:text-primary text-mono font-semibold" href="#">
											Adrian Vale
										</a>
										<span class="text-secondary-foreground">
											change the due date of
										</span>
										<a class="hover:text-primary text-primary" href="#">
											Marketing
										</a>
										to 13 May
									</div>
									<span class="flex items-center text-xs font-medium text-muted-foreground">
										2 days ago
										<span class="rounded-full size-1 bg-mono/30 mx-1.5">
										</span>
										Marketing
									</span>
								</div>
							</div>
							<div class="border-b border-b-border">
							</div>
							<div class="flex grow gap-2.5 px-5">
								<div class="kt-avatar size-8">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-12.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
								<div class="flex flex-col gap-3.5 grow">
									<div class="flex flex-col gap-1">
										<div class="text-sm font-medium mb-px">
											<a class="hover:text-primary text-mono font-semibold" href="#">
												Skylar Frost
											</a>
											<span class="text-secondary-foreground">
												uploaded 2 attachments
											</span>
										</div>
										<span class="flex items-center text-xs font-medium text-muted-foreground">
											3 days ago
											<span class="rounded-full size-1 bg-mono/30 mx-1.5">
											</span>
											Web Design
										</span>
									</div>
									<div
										class="kt-card shadow-none flex items-center justify-between flex-row gap-1.5 p-2.5 rounded-lg bg-muted/70">
										<div class="flex items-center gap-1.5">
											<img class="h-6" src="assets/media/file-types/word.svg" />
											<div class="flex flex-col gap-0.5">
												<a class="hover:text-primary font-medium text-secondary-foreground text-xs"
													href="#">
													Landing-page.docx
												</a>
												<span class="font-medium text-muted-foreground text-xs">
													1.9 MB
												</span>
											</div>
										</div>
										<button class="kt-btn kt-btn-sm kt-btn-icon kt-btn-ghost">
											<svg fill="none" height="14" viewbox="0 0 14 14" width="14"
												xmlns="http://www.w3.org/2000/svg">
												<path clip-rule="evenodd"
													d="M6.63821 2.60467C4.81926 2.60467 3.32474 3.99623 3.16201 5.77252C3.1386 6.02803 2.92413 6.22253 2.66871 6.22227C1.74915 6.22149 0.976744 6.9868 0.976744 7.90442C0.976744 8.83344 1.72988 9.58657 2.65891 9.58657H3.09302C3.36274 9.58657 3.5814 9.80523 3.5814 10.0749C3.5814 10.3447 3.36274 10.5633 3.09302 10.5633H2.65891C1.19044 10.5633 0 9.37292 0 7.90442C0 6.58614 0.986948 5.48438 2.24496 5.27965C2.62863 3.20165 4.44941 1.62793 6.63821 1.62793C8.26781 1.62793 9.69282 2.50042 10.4729 3.80193C12.3411 3.72829 14 5.2564 14 7.18091C14 8.93508 12.665 10.3769 10.9552 10.5466C10.6868 10.5733 10.4476 10.3773 10.421 10.1089C10.3943 9.84052 10.5903 9.60135 10.8587 9.57465C12.0739 9.45406 13.0233 8.42802 13.0233 7.18091C13.0233 5.74002 11.6905 4.59666 10.2728 4.79968C10.0642 4.82957 9.85672 4.72382 9.76028 4.53181C9.18608 3.38796 8.00318 2.60467 6.63821 2.60467Z"
													fill="#99A1B7" fill-rule="evenodd">
												</path>
												<path clip-rule="evenodd"
													d="M6.99909 8.01611L8.28162 9.29864C8.47235 9.48937 8.78158 9.48937 8.97231 9.29864C9.16303 9.10792 9.16303 8.79874 8.97231 8.60802L7.57465 7.2103C7.25675 6.89247 6.74143 6.89247 6.42353 7.2103L5.02585 8.60802C4.83513 8.79874 4.83513 9.10792 5.02585 9.29864C5.21657 9.48937 5.5258 9.48937 5.71649 9.29864L6.99909 8.01611Z"
													fill="#99A1B7" fill-rule="evenodd">
												</path>
												<path clip-rule="evenodd"
													d="M7.00009 12.372C7.2698 12.372 7.48846 12.1533 7.48846 11.8836V7.97665C7.48846 7.70694 7.2698 7.48828 7.00009 7.48828C6.73038 7.48828 6.51172 7.70694 6.51172 7.97665V11.8836C6.51172 12.1533 6.73038 12.372 7.00009 12.372Z"
													fill="#99A1B7" fill-rule="evenodd">
												</path>
											</svg>
										</button>
									</div>
									<div
										class="kt-card shadow-none flex items-center justify-between flex-row gap-1.5 p-2.5 rounded-lg bg-muted/70">
										<div class="flex items-center gap-1.5">
											<img class="h-6" src="assets/media/file-types/svg.svg" />
											<div class="flex flex-col gap-0.5">
												<a class="hover:text-primary font-medium text-secondary-foreground text-xs"
													href="#">
													New-icon.svg
												</a>
												<span class="font-medium text-muted-foreground text-xs">
													2.3 MB
												</span>
											</div>
										</div>
										<button class="kt-btn kt-btn-sm kt-btn-icon kt-btn-ghost">
											<svg fill="none" height="14" viewbox="0 0 14 14" width="14"
												xmlns="http://www.w3.org/2000/svg">
												<path clip-rule="evenodd"
													d="M6.63821 2.60467C4.81926 2.60467 3.32474 3.99623 3.16201 5.77252C3.1386 6.02803 2.92413 6.22253 2.66871 6.22227C1.74915 6.22149 0.976744 6.9868 0.976744 7.90442C0.976744 8.83344 1.72988 9.58657 2.65891 9.58657H3.09302C3.36274 9.58657 3.5814 9.80523 3.5814 10.0749C3.5814 10.3447 3.36274 10.5633 3.09302 10.5633H2.65891C1.19044 10.5633 0 9.37292 0 7.90442C0 6.58614 0.986948 5.48438 2.24496 5.27965C2.62863 3.20165 4.44941 1.62793 6.63821 1.62793C8.26781 1.62793 9.69282 2.50042 10.4729 3.80193C12.3411 3.72829 14 5.2564 14 7.18091C14 8.93508 12.665 10.3769 10.9552 10.5466C10.6868 10.5733 10.4476 10.3773 10.421 10.1089C10.3943 9.84052 10.5903 9.60135 10.8587 9.57465C12.0739 9.45406 13.0233 8.42802 13.0233 7.18091C13.0233 5.74002 11.6905 4.59666 10.2728 4.79968C10.0642 4.82957 9.85672 4.72382 9.76028 4.53181C9.18608 3.38796 8.00318 2.60467 6.63821 2.60467Z"
													fill="#99A1B7" fill-rule="evenodd">
												</path>
												<path clip-rule="evenodd"
													d="M6.99909 8.01611L8.28162 9.29864C8.47235 9.48937 8.78158 9.48937 8.97231 9.29864C9.16303 9.10792 9.16303 8.79874 8.97231 8.60802L7.57465 7.2103C7.25675 6.89247 6.74143 6.89247 6.42353 7.2103L5.02585 8.60802C4.83513 8.79874 4.83513 9.10792 5.02585 9.29864C5.21657 9.48937 5.5258 9.48937 5.71649 9.29864L6.99909 8.01611Z"
													fill="#99A1B7" fill-rule="evenodd">
												</path>
												<path clip-rule="evenodd"
													d="M7.00009 12.372C7.2698 12.372 7.48846 12.1533 7.48846 11.8836V7.97665C7.48846 7.70694 7.2698 7.48828 7.00009 7.48828C6.73038 7.48828 6.51172 7.70694 6.51172 7.97665V11.8836C6.51172 12.1533 6.73038 12.372 7.00009 12.372Z"
													fill="#99A1B7" fill-rule="evenodd">
												</path>
											</svg>
										</button>
									</div>
								</div>
							</div>
							<div class="border-b border-b-border">
							</div>
							<div class="flex grow gap-2.5 px-5">
								<div class="kt-avatar size-8">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-21.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
								<div class="flex flex-col gap-3.5">
									<div class="flex flex-col gap-1">
										<div class="text-sm font-medium">
											<a class="hover:text-primary text-mono font-semibold" href="#">
												Selene Silverleaf
											</a>
											<span class="text-secondary-foreground">
												commented on
											</span>
											<a class="hover:text-primary text-primary" href="#">
												SiteSculpt
											</a>
											<span class="text-secondary-foreground">
											</span>
										</div>
										<span class="flex items-center text-xs font-medium text-muted-foreground">
											4 days ago
											<span class="rounded-full size-1 bg-mono/30 mx-1.5">
											</span>
											Manager
										</span>
									</div>
									<div class="kt-card shadow-none flex flex-col gap-2.5 p-3.5 rounded-lg bg-muted/70">
										<div class="text-sm font-semibold text-secondary-foreground mb-px">
											<a class="hover:text-primary text-mono font-semibold" href="#">
												&#64;Cody
											</a>
											<span class="text-secondary-foreground font-medium">
												This
												design is simply stunning! From layout to color, it's a work of art!
											</span>
										</div>
										<div class="kt-input">
											<input placeholder="Reply" type="text" value="" />
											<button class="kt-btn kt-btn-ghost kt-btn-icon size-6 -me-1.5">
												<i class="ki-filled ki-picture">
												</i>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div class="border-b border-b-border">
							</div>
							<div class="flex grow gap-2.5 px-5" id="notification_request_3">
								<div class="kt-avatar size-8">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-13.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
								<div class="flex flex-col gap-3.5">
									<div class="flex flex-col gap-1">
										<div class="text-sm font-medium mb-px">
											<a class="hover:text-primary text-mono font-semibold" href="#">
												Thalia Fox
											</a>
											<span class="text-secondary-foreground">
												has invited you
												to join
											</span>
											<a class="hover:text-primary text-primary" href="#">
												Design Research
											</a>
											<span class="text-secondary-foreground">
											</span>
										</div>
										<span class="flex items-center text-xs font-medium text-muted-foreground">
											4 days ago
											<span class="rounded-full size-1 bg-mono/30 mx-1.5">
											</span>
											Dev
											Team
										</span>
									</div>
									<div class="flex flex-wrap gap-2.5">
										<button class="kt-btn kt-btn-outline kt-btn-sm"
											data-kt-dismiss="#notification_request_3">
											Decline
										</button>
										<button class="kt-btn kt-btn-mono kt-btn-sm"
											data-kt-dismiss="#notification_request_3">
											Accept
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="border-b border-b-border">
					</div>
					<div class="grid grid-cols-2 p-5 gap-2.5" id="notifications_team_footer">
						<button class="kt-btn kt-btn-outline justify-center">
							Archive all
						</button>
						<button class="kt-btn kt-btn-outline justify-center">
							Mark all as read
						</button>
					</div>
				</div>
				<div class="grow flex flex-col hidden" id="notifications_tab_following">
					<div class="grow kt-scrollable-y-auto" data-kt-scrollable="true"
						data-kt-scrollable-dependencies="#header" data-kt-scrollable-max-height="auto"
						data-kt-scrollable-offset="150px">
						<div class="flex flex-col gap-5 pt-3 pb-4">
							<div class="flex grow gap-2.5 px-5">
								<div class="kt-avatar size-8">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-1.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
								<div class="flex flex-col gap-2.5 grow">
									<div class="flex flex-col gap-1 mb-1">
										<div class="text-sm font-medium mb-px">
											<a class="hover:text-primary text-mono font-semibold" href="#">
												Jane Perez
											</a>
											<span class="text-secondary-foreground">
												added 2 new works to
											</span>
											<a class="hover:text-primary text-primary font-semibold" href="#">
												Inspirations 2024
											</a>
										</div>
										<span class="flex items-center text-xs font-medium text-muted-foreground">
											23 hours ago
											<span class="rounded-full size-1 bg-mono/30 mx-1.5">
											</span>
											Craftwork Design
										</span>
									</div>
									<div class="flex items-center gap-2.5">
										<div class="kt-card shadow-none flex flex-col gap-3.5 bg-muted/70 w-40">
											<div class="bg-cover bg-no-repeat kt-card-rounded-t shrink-0 h-24"
												style="background-image: url('assets/media/images/600x600/6.jpg')">
											</div>
											<div class="px-2.5 pb-2">
												<a class="font-medium block text-secondary-foreground hover:text-primary text-xs leading-4 mb-0.5"
													href="#">
													Geometric Patterns
												</a>
												<div class="text-xs font-medium text-muted-foreground">
													Token ID:
													<span class="text-xs font-medium text-secondary-foreground">
														81023
													</span>
												</div>
											</div>
										</div>
										<div class="kt-card shadow-none flex flex-col gap-3.5 bg-muted/70 w-40">
											<div class="bg-cover bg-no-repeat kt-card-rounded-t shrink-0 h-24"
												style="background-image: url('assets/media/images/600x600/1.jpg')">
											</div>
											<div class="px-2.5 pb-2">
												<a class="font-medium block text-secondary-foreground hover:text-primary text-xs leading-4 mb-0.5"
													href="#">
													Artistic Expressions
												</a>
												<div class="text-xs font-medium text-muted-foreground">
													Token ID:
													<span class="text-xs font-medium text-secondary-foreground">
														67890
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="border-b border-b-border">
							</div>
							<div class="flex grow gap-2.5 px-5" id="notification_request_17">
								<div class="kt-avatar size-8">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-19.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
								<div class="flex flex-col gap-2.5 grow">
									<div class="flex flex-col gap-1 mb-1">
										<div class="text-sm font-medium mb-px">
											<a class="hover:text-primary text-mono font-semibold" href="#">
												Natalie Wood
											</a>
											<span class="text-secondary-foreground">
												wants to edit marketing project
											</span>
										</div>
										<span class="flex items-center text-xs font-medium text-muted-foreground">
											1 day ago
											<span class="rounded-full size-1 bg-mono/30 mx-1.5">
											</span>
											Designer
										</span>
									</div>
									<div
										class="kt-card shadow-none flex items-center flex-row gap-1.5 p-2.5 rounded-lg bg-muted/70">
										<div
											class="flex items-center justify-center w-[26px] h-[30px] shrink-0 bg-white rounded-sm border border-border">
											<img class="h-5" src="assets/media/brand-logos/jira.svg" />
										</div>
										<a class="hover:text-primary font-medium text-secondary-foreground text-xs me-1"
											href="#">
											User-feedback.jira
										</a>
										<span class="font-medium text-muted-foreground text-xs">
											Edited 1 hour ago
										</span>
									</div>
									<div class="flex flex-wrap gap-2.5">
										<button class="kt-btn kt-btn-outline kt-btn-sm"
											data-kt-dismiss="#notification_request_17">
											Decline
										</button>
										<button class="kt-btn kt-btn-mono kt-btn-sm"
											data-kt-dismiss="#notification_request_17">
											Accept
										</button>
									</div>
								</div>
							</div>
							<div class="border-b border-b-border">
							</div>
							<div class="flex grow gap-2.5 px-5">
								<div class="kt-avatar size-8">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-17.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
								<div class="flex flex-col gap-2.5 grow">
									<div class="flex flex-col gap-1 mb-1">
										<div class="text-sm font-medium mb-px">
											<a class="hover:text-primary text-mono font-semibold" href="#">
												Aaron Foster
											</a>
											<span class="text-secondary-foreground">
												requested to view
											</span>
										</div>
										<span class="flex items-center text-xs font-medium text-muted-foreground">
											3 day ago
											<span class="rounded-full size-1 bg-mono/30 mx-1.5">
											</span>
											Larsen Ltd
										</span>
									</div>
									<div
										class="kt-card shadow-none flex items-center flex-row gap-1.5 px-2.5 py-1.5 rounded-lg bg-muted/70">
										<i class="ki-filled ki-user-tick text-green-500 text-base">
										</i>
										<span class="font-medium text-green-500 text-sm">
											You allowed Aaron to view
										</span>
									</div>
								</div>
							</div>
							<div class="border-b border-b-border">
							</div>
							<div class="flex grow gap-2.5 px-5">
								<div class="kt-avatar size-8">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-34.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
								<div class="flex flex-col gap-1">
									<div class="text-sm font-medium mb-px">
										<a class="hover:text-primary text-mono font-semibold" href="#">
											Chloe Morgan
										</a>
										<span class="text-secondary-foreground">
											posted a new
											article
										</span>
										<a class="hover:text-primary text-primary" href="#">
											User Experience
										</a>
									</div>
									<span class="flex items-center text-xs font-medium text-muted-foreground">
										1 day ago
										<span class="rounded-full size-1 bg-mono/30 mx-1.5">
										</span>
										Nexus
									</span>
								</div>
							</div>
							<div class="border-b border-b-border">
							</div>
							<div class="flex grow gap-2.5 px-5">
								<div class="kt-avatar size-8">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-9.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
								<div class="flex flex-col gap-2.5 grow">
									<div class="flex flex-col gap-1 mb-1">
										<div class="text-sm font-medium mb-px">
											<a class="hover:text-primary text-mono font-semibold" href="#">
												Gabriel Bennett
											</a>
											<span class="text-secondary-foreground">
												started connect you
											</span>
										</div>
										<span class="flex items-center text-xs font-medium text-muted-foreground">
											3 day ago
											<span class="rounded-full size-1 bg-mono/30 mx-1.5">
											</span>
											Development
										</span>
									</div>
									<div class="flex flex-wrap gap-2.5">
										<button class="kt-btn kt-btn-sm kt-btn-outline">
											<i class="ki-filled ki-check-circle">
											</i>
											Connected
										</button>
										<button class="kt-btn kt-btn-mono kt-btn-sm">
											Go to profile
										</button>
									</div>
								</div>
							</div>
							<div class="border-b border-b-border">
							</div>
							<div class="flex grow gap-2.5 px-5" id="notification_request_3">
								<div class="kt-avatar size-8">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-13.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
								<div class="flex flex-col gap-3.5">
									<div class="flex flex-col gap-1">
										<div class="text-sm font-medium mb-px">
											<a class="hover:text-primary text-mono font-semibold" href="#">
												Thalia Fox
											</a>
											<span class="text-secondary-foreground">
												has invited you
												to join
											</span>
											<a class="hover:text-primary text-primary" href="#">
												Design Research
											</a>
											<span class="text-secondary-foreground">
											</span>
										</div>
										<span class="flex items-center text-xs font-medium text-muted-foreground">
											4 days ago
											<span class="rounded-full size-1 bg-mono/30 mx-1.5">
											</span>
											Dev
											Team
										</span>
									</div>
									<div class="flex flex-wrap gap-2.5">
										<button class="kt-btn kt-btn-outline kt-btn-sm"
											data-kt-dismiss="#notification_request_3">
											Decline
										</button>
										<button class="kt-btn kt-btn-mono kt-btn-sm"
											data-kt-dismiss="#notification_request_3">
											Accept
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="border-b border-b-border">
					</div>
					<div class="grid grid-cols-2 p-5 gap-2.5" id="notifications_following_footer">
						<button class="kt-btn kt-btn-outline justify-center">
							Archive all
						</button>
						<button class="kt-btn kt-btn-outline justify-center">
							Mark all as read
						</button>
					</div>
				</div>
			</div>
			<!--End of Notifications Drawer-->
			<!-- End of Notifications -->
			<!-- Chat -->
			<button
				class="kt-btn kt-btn-ghost kt-btn-icon size-9 rounded-full hover:bg-primary/10 hover:[&_i]:text-primary"
				data-kt-drawer-toggle="#chat_drawer">
				<i class="ki-filled ki-messages text-lg">
				</i>
			</button>
			<!--Chat Drawer-->
			<div class="hidden kt-drawer kt-drawer-end card flex-col max-w-[90%] w-[450px] top-5 bottom-5 end-5 rounded-xl border border-border"
				data-kt-drawer="true" data-kt-drawer-container="body" id="chat_drawer">
				<div>
					<div class="flex items-center justify-between gap-2.5 text-sm text-mono font-semibold px-5 py-3.5">
						Chat
						<button class="kt-btn kt-btn-sm kt-btn-icon kt-btn-dim shrink-0" data-kt-drawer-dismiss="true">
							<i class="ki-filled ki-cross">
							</i>
						</button>
					</div>
					<div class="border-b border-b-border">
					</div>
					<div class="border-b border-border py-2.5">
						<div class="flex items-center justify-between flex-wrap gap-2 px-5">
							<div class="flex items-center flex-wrap gap-2">
								<div
									class="flex items-center justify-center shrink-0 rounded-full bg-accent/60 border border-border size-11">
									<img alt="" class="size-7" src="assets/media/brand-logos/gitlab.svg" />
								</div>
								<div class="flex flex-col">
									<a class="text-sm font-semibold text-mono hover:text-primary" href="#">
										HR Team
									</a>
									<span class="text-xs font-medium italic text-muted-foreground">
										Jessy is typing..
									</span>
								</div>
							</div>
							<div class="flex items-center gap-2.5">
								<div class="flex -space-x-2">
									<div class="flex">
										<img class="hover:z-5 relative shrink-0 rounded-full ring-1 ring-background size-[30px]"
											src="assets/media/avatars/300-4.png" />
									</div>
									<div class="flex">
										<img class="hover:z-5 relative shrink-0 rounded-full ring-1 ring-background size-[30px]"
											src="assets/media/avatars/300-1.png" />
									</div>
									<div class="flex">
										<img class="hover:z-5 relative shrink-0 rounded-full ring-1 ring-background size-[30px]"
											src="assets/media/avatars/300-2.png" />
									</div>
									<div class="flex">
										<span
											class="hover:z-5 relative inline-flex items-center justify-center shrink-0 rounded-full ring-1 font-semibold leading-none text-2xs size-[30px] text-white size-6 ring-background bg-green-500">
											+10
										</span>
									</div>
								</div>
								<div class="kt-menu" data-kt-menu="true">
									<div class="kt-menu-item" data-kt-menu-item-offset="0, 10px"
										data-kt-menu-item-placement="bottom-end"
										data-kt-menu-item-placement-rtl="bottom-start"
										data-kt-menu-item-toggle="dropdown" data-kt-menu-item-trigger="click|lg:hover">
										<button class="kt-menu-toggle kt-btn kt-btn-sm kt-btn-icon kt-btn-ghost">
											<i class="ki-filled ki-dots-vertical text-lg">
											</i>
										</button>
										<div class="kt-menu-dropdown kt-menu-default w-full max-w-[175px]"
											data-kt-menu-dismiss="true">
											<div class="kt-menu-item">
												<a class="kt-menu-link" href="#">
													<span class="kt-menu-icon">
														<i class="ki-filled ki-users">
														</i>
													</span>
													<span class="kt-menu-title">
														Invite Users
													</span>
												</a>
											</div>
											<div class="kt-menu-item" data-kt-menu-item-offset="-15px, 0"
												data-kt-menu-item-placement="right-start"
												data-kt-menu-item-toggle="dropdown"
												data-kt-menu-item-trigger="click|lg:hover">
												<div class="kt-menu-link">
													<span class="kt-menu-icon">
														<i class="ki-filled ki-people">
														</i>
													</span>
													<span class="kt-menu-title">
														Team
													</span>
													<span class="kt-menu-arrow">
														<i
															class="ki-filled ki-right text-xs rtl:transform rtl:rotate-180">
														</i>
													</span>
												</div>
												<div class="kt-menu-dropdown kt-menu-default w-full max-w-[175px]">
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-shield-search">
																</i>
															</span>
															<span class="kt-menu-title">
																Find Members
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-calendar">
																</i>
															</span>
															<span class="kt-menu-title">
																Meetings
															</span>
														</a>
													</div>
													<div class="kt-menu-item">
														<a class="kt-menu-link"
															href="#">
															<span class="kt-menu-icon">
																<i class="ki-filled ki-filter-edit">
																</i>
															</span>
															<span class="kt-menu-title">
																Group Settings
															</span>
														</a>
													</div>
												</div>
											</div>
											<div class="kt-menu-item">
												<a class="kt-menu-link"
													href="#">
													<span class="kt-menu-icon">
														<i class="ki-filled ki-setting-3">
														</i>
													</span>
													<span class="kt-menu-title">
														Settings
													</span>
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="kt-scrollable-y-auto grow" data-kt-scrollable="true"
					data-kt-scrollable-dependencies="#header" data-kt-scrollable-max-height="auto"
					data-kt-scrollable-offset="230px">
					<div class="flex flex-col gap-5 py-5">
						<div class="flex items-end gap-3.5 px-5">
							<img alt="" class="rounded-full size-9" src="assets/media/avatars/300-5.png" />
							<div class="flex flex-col gap-1.5">
								<div
									class="kt-card shadow-none flex flex-col bg-accent/60 gap-2.5 p-3 rounded-bs-none text-2sm">
									Next week we are closing the project. Do You have questions?
								</div>
								<span class="text-xs font-medium text-muted-foreground">
									14:04
								</span>
							</div>
						</div>
						<div class="flex items-end justify-end gap-3.5 px-5">
							<div class="flex flex-col gap-1.5">
								<div class="kt-card shadow-none flex bg-primary flex-col gap-2.5 p-3 rounded-be-none">
									<p class="text-2sm font-medium text-primary-foreground">
										This is excellent news!
									</p>
								</div>
								<div class="flex items-center justify-end gap-2 relative">
									<span class="text-xs font-medium text-secondary-foreground">
										14:08
									</span>
									<i class="ki-filled ki-double-check text-lg absolute text-green-500">
									</i>
								</div>
							</div>
							<div class="relative shrink-0">
								<div class="kt-avatar size-9">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-2.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="flex items-end gap-3.5 px-5">
							<img alt="" class="rounded-full size-9" src="assets/media/avatars/300-4.png" />
							<div class="flex flex-col gap-1.5">
								<div
									class="kt-card shadow-none flex flex-col bg-accent/60 gap-2.5 p-3 rounded-bs-none text-2sm">
									I have checked the features, can not wait to demo them!
								</div>
								<span class="text-xs font-medium text-muted-foreground">
									14:26
								</span>
							</div>
						</div>
						<div class="flex items-end gap-3.5 px-5">
							<img alt="" class="rounded-full size-9" src="assets/media/avatars/300-1.png" />
							<div class="flex flex-col gap-1.5">
								<div
									class="kt-card shadow-none flex flex-col bg-accent/60 gap-2.5 p-3 rounded-bs-none text-2sm">
									I have looked over the rollout plan, and everything seems spot on.
								</div>
								<span class="text-xs font-medium text-muted-foreground">
									15:09
								</span>
							</div>
						</div>
						<div class="flex items-end justify-end gap-3.5 px-5">
							<div class="flex flex-col gap-1.5">
								<div class="kt-card shadow-none flex bg-primary flex-col gap-2.5 p-3 rounded-be-none">
									<p class="text-2sm font-medium text-primary-foreground">
										Haven't seen the build yet, I'll look now.
									</p>
								</div>
								<div class="flex items-center justify-end gap-2 relative">
									<span class="text-xs font-medium text-secondary-foreground">
										15:52
									</span>
									<i class="ki-filled ki-double-check text-lg absolute text-muted-foreground">
									</i>
								</div>
							</div>
							<div class="relative shrink-0">
								<div class="kt-avatar size-9">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-2.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="flex items-end justify-end gap-3.5 px-5">
							<div class="flex flex-col gap-1.5">
								<div class="kt-card shadow-none flex bg-primary flex-col gap-2.5 p-3 rounded-be-none">
									<p class="text-2sm font-medium text-primary-foreground">
										Checking the build now
									</p>
								</div>
								<div class="flex items-center justify-end gap-2 relative">
									<span class="text-xs font-medium text-secondary-foreground">
										15:52
									</span>
									<i class="ki-filled ki-double-check text-lg absolute text-muted-foreground">
									</i>
								</div>
							</div>
							<div class="relative shrink-0">
								<div class="kt-avatar size-9">
									<div class="kt-avatar-image">
										<img alt="avatar" src="assets/media/avatars/300-2.png" />
									</div>
									<div class="kt-avatar-indicator -end-2 -bottom-2">
										<div class="kt-avatar-status kt-avatar-status-online size-2.5">
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="flex items-end gap-3.5 px-5">
							<img alt="" class="rounded-full size-9" src="assets/media/avatars/300-4.png" />
							<div class="flex flex-col gap-1.5">
								<div
									class="kt-card shadow-none flex flex-col bg-accent/60 gap-2.5 p-3 rounded-bs-none text-2sm">
									Tomorrow, I will send the link for the meeting
								</div>
								<span class="text-xs font-medium text-muted-foreground">
									17:40
								</span>
							</div>
						</div>
					</div>
				</div>
				<!--Chat Footer-->
				<div class="mb-2.5">
					<div class="flex grow gap-2 px-5 py-3.5 bg-accent/60 mb-2.5 border-y border-border"
						id="join_request">
						<div class="kt-avatar size-9">
							<div class="kt-avatar-image">
								<img alt="avatar" src="assets/media/avatars/300-14.png" />
							</div>
							<div class="kt-avatar-indicator -end-2 -bottom-2">
								<div class="kt-avatar-status kt-avatar-status-online size-2.5">
								</div>
							</div>
						</div>
						<div class="flex items-center justify-between gap-3 grow">
							<div class="flex flex-col">
								<div class="text-sm mb-px">
									<a class="hover:text-primary font-semibold text-mono" href="#">
										Jane Perez
									</a>
									<span class="text-secondary-foreground">
										wants to join chat
									</span>
								</div>
								<span class="flex items-center text-xs font-medium text-muted-foreground">
									1 day ago
									<span class="rounded-full size-1 bg-mono/30 mx-1.5">
									</span>
									Design Team
								</span>
							</div>
							<div class="flex gap-2.5">
								<button class="kt-btn kt-btn-sm kt-btn-outline kt-btn-sm"
									data-kt-dismiss="#join_request">
									Decline
								</button>
								<button class="kt-btn kt-btn-sm kt-btn-mono kt-btn-sm">
									Accept
								</button>
							</div>
						</div>
					</div>
					<div class="relative grow mx-5">
						<img alt="" class="rounded-full size-[30px] absolute start-0 top-2/4 -translate-y-2/4 ms-2.5"
							src="assets/media/avatars/300-2.png" />
						<input class="kt-input h-auto py-4 ps-12 bg-transparent" placeholder="Write a message..."
							type="text" value="" />
						<div class="flex items-center gap-2.5 absolute end-3 top-1/2 -translate-y-1/2">
							<button class="kt-btn kt-btn-sm kt-btn-icon kt-btn-ghost">
								<i class="ki-filled ki-exit-up">
								</i>
							</button>
							<a class="kt-btn kt-btn-mono kt-btn-sm" href="#">
								Send
							</a>
						</div>
					</div>
				</div>
				<!--End of Chat Footer-->
			</div>
			<!--End of Chat Drawer-->
			<!-- End of Chat -->
			<!-- Apps -->
			<div data-kt-dropdown="true" data-kt-dropdown-offset="10px, 10px" data-kt-dropdown-offset-rtl="-10px, 10px"
				data-kt-dropdown-placement="bottom-end" data-kt-dropdown-placement-rtl="bottom-start">
				<button
					class="kt-btn kt-btn-ghost kt-btn-icon size-9 rounded-full hover:bg-primary/10 hover:[&_i]:text-primary kt-dropdown-open:bg-primary/10 kt-dropdown-open:[&_i]:text-primary"
					data-kt-dropdown-toggle="true">
					<i class="ki-filled ki-element-11 text-lg">
					</i>
				</button>
				<div class="kt-dropdown-menu p-0 w-screen max-w-[320px]" data-kt-dropdown-menu="true">
					<div
						class="flex items-center justify-between gap-2.5 text-xs text-secondary-foreground font-medium px-5 py-3 border-b border-b-border">
						<span>
							Apps
						</span>
						<span>
							Enabled
						</span>
					</div>
					<div class="flex flex-col kt-scrollable-y-auto max-h-[400px] divide-y divide-border">
						<div class="flex items-center justify-between flex-wrap gap-2 px-5 py-3.5">
							<div class="flex items-center flex-wrap gap-2">
								<div
									class="flex items-center justify-center shrink-0 rounded-full bg-accent/60 border border-border size-10">
									<img alt="" class="size-6" src="assets/media/brand-logos/jira.svg" />
								</div>
								<div class="flex flex-col">
									<a class="text-sm font-semibold text-mono hover:text-primary" href="#">
										Jira
									</a>
									<span class="text-xs font-medium text-secondary-foreground">
										Project management
									</span>
								</div>
							</div>
							<div class="flex items-center gap-2 lg:gap-5">
								<input class="kt-switch" type="checkbox" value="1" />
							</div>
						</div>
						<div class="flex items-center justify-between flex-wrap gap-2 px-5 py-3.5">
							<div class="flex items-center flex-wrap gap-2">
								<div
									class="flex items-center justify-center shrink-0 rounded-full bg-accent/60 border border-border size-10">
									<img alt="" class="size-6" src="assets/media/brand-logos/inferno.svg" />
								</div>
								<div class="flex flex-col">
									<a class="text-sm font-semibold text-mono hover:text-primary" href="#">
										Inferno
									</a>
									<span class="text-xs font-medium text-secondary-foreground">
										Ensures healthcare app
									</span>
								</div>
							</div>
							<div class="flex items-center gap-2 lg:gap-5">
								<input checked="" class="kt-switch" type="checkbox" value="1" />
							</div>
						</div>
						<div class="flex items-center justify-between flex-wrap gap-2 px-5 py-3.5">
							<div class="flex items-center flex-wrap gap-2">
								<div
									class="flex items-center justify-center shrink-0 rounded-full bg-accent/60 border border-border size-10">
									<img alt="" class="size-6" src="assets/media/brand-logos/evernote.svg" />
								</div>
								<div class="flex flex-col">
									<a class="text-sm font-semibold text-mono hover:text-primary" href="#">
										Evernote
									</a>
									<span class="text-xs font-medium text-secondary-foreground">
										Notes management app
									</span>
								</div>
							</div>
							<div class="flex items-center gap-2 lg:gap-5">
								<input checked="" class="kt-switch" type="checkbox" value="1" />
							</div>
						</div>
						<div class="flex items-center justify-between flex-wrap gap-2 px-5 py-3.5">
							<div class="flex items-center flex-wrap gap-2">
								<div
									class="flex items-center justify-center shrink-0 rounded-full bg-accent/60 border border-border size-10">
									<img alt="" class="size-6" src="assets/media/brand-logos/gitlab.svg" />
								</div>
								<div class="flex flex-col">
									<a class="text-sm font-semibold text-mono hover:text-primary" href="#">
										Gitlab
									</a>
									<span class="text-xs font-medium text-secondary-foreground">
										DevOps platform
									</span>
								</div>
							</div>
							<div class="flex items-center gap-2 lg:gap-5">
								<input class="kt-switch" type="checkbox" value="1" />
							</div>
						</div>
						<div class="flex items-center justify-between flex-wrap gap-2 px-5 py-3.5">
							<div class="flex items-center flex-wrap gap-2">
								<div
									class="flex items-center justify-center shrink-0 rounded-full bg-accent/60 border border-border size-10">
									<img alt="" class="size-6" src="assets/media/brand-logos/google-webdev.svg" />
								</div>
								<div class="flex flex-col">
									<a class="text-sm font-semibold text-mono hover:text-primary" href="#">
										Google webdev
									</a>
									<span class="text-xs font-medium text-secondary-foreground">
										Building web expierences
									</span>
								</div>
							</div>
							<div class="flex items-center gap-2 lg:gap-5">
								<input checked="" class="kt-switch" type="checkbox" value="1" />
							</div>
						</div>
					</div>
					<div class="grid p-5 border-t border-t-border">
						<a class="kt-btn kt-btn-outline justify-center" href="#">
							Go to Apps
						</a>
					</div>
				</div>
			</div>
			<!-- End of Apps -->
			<!-- User -->
			<div class="shrink-0" data-kt-dropdown="true" data-kt-dropdown-offset="10px, 10px"
				data-kt-dropdown-offset-rtl="-20px, 10px" data-kt-dropdown-placement="bottom-end"
				data-kt-dropdown-placement-rtl="bottom-start" data-kt-dropdown-trigger="click">
				<div class="cursor-pointer shrink-0" data-kt-dropdown-toggle="true">
					<img alt="" class="size-9 rounded-full border-2 border-green-500 shrink-0"
						src="assets/media/avatars/300-2.png" />
				</div>
				<div class="kt-dropdown-menu w-[250px]" data-kt-dropdown-menu="true">
					<div class="flex items-center justify-between px-2.5 py-1.5 gap-1.5">
						<div class="flex items-center gap-2">
							<img alt="" class="size-9 shrink-0 rounded-full border-2 border-green-500"
								src="assets/media/avatars/300-2.png" />
							<div class="flex flex-col gap-1.5">
								<span class="text-sm text-foreground font-semibold leading-none">
									Cody Fisher
								</span>
								<a class="text-xs text-secondary-foreground hover:text-primary font-medium leading-none"
									href="#">
									c.fisher&#64;gmail.com
								</a>
							</div>
						</div>
						<span class="kt-badge kt-badge-sm kt-badge-primary kt-badge-outline">
							Pro
						</span>
					</div>
					<ul class="kt-dropdown-menu-sub">
						<li>
							<div class="kt-dropdown-menu-separator">
							</div>
						</li>
						<li>
							<a class="kt-dropdown-menu-link" href="#">
								<i class="ki-filled ki-badge">
								</i>
								Public Profile
							</a>
						</li>
						<li>
							<a class="kt-dropdown-menu-link" href="#">
								<i class="ki-filled ki-profile-circle">
								</i>
								My Profile
							</a>
						</li>
						<li data-kt-dropdown="true" data-kt-dropdown-placement="right-start"
							data-kt-dropdown-trigger="hover">
							<button class="kt-dropdown-menu-toggle" data-kt-dropdown-toggle="true">
								<i class="ki-filled ki-setting-2">
								</i>
								My Account
								<span class="kt-dropdown-menu-indicator">
									<i class="ki-filled ki-right text-xs">
									</i>
								</span>
							</button>
							<div class="kt-dropdown-menu w-[220px]" data-kt-dropdown-menu="true">
								<ul class="kt-dropdown-menu-sub">
									<li>
										<a class="kt-dropdown-menu-link"
											href="#">
											<i class="ki-filled ki-coffee">
											</i>
											Get Started
										</a>
									</li>
									<li>
										<a class="kt-dropdown-menu-link"
											href="#">
											<i class="ki-filled ki-some-files">
											</i>
											My Profile
										</a>
									</li>
									<li>
										<a class="kt-dropdown-menu-link" href="#">
											<span class="flex items-center gap-2">
												<i class="ki-filled ki-icon">
												</i>
												Billing
											</span>
											<span class="ms-auto inline-flex items-center" data-kt-tooltip="true"
												data-kt-tooltip-placement="top">
												<i class="ki-filled ki-information-2 text-base text-muted-foreground">
												</i>
												<span class="kt-tooltip" data-kt-tooltip-content="true">
													Payment and subscription info
												</span>
											</span>
										</a>
									</li>
									<li>
										<a class="kt-dropdown-menu-link"
											href="#">
											<i class="ki-filled ki-medal-star">
											</i>
											Security
										</a>
									</li>
									<li>
										<a class="kt-dropdown-menu-link" href="#">
											<i class="ki-filled ki-setting">
											</i>
											Members & Roles
										</a>
									</li>
									<li>
										<a class="kt-dropdown-menu-link" href="#">
											<i class="ki-filled ki-switch">
											</i>
											Integrations
										</a>
									</li>
									<li>
										<div class="kt-dropdown-menu-separator">
										</div>
									</li>
									<li>
										<a class="kt-dropdown-menu-link"
											href="#">
											<span class="flex items-center gap-2">
												<i class="ki-filled ki-shield-tick">
												</i>
												Notifications
											</span>
											<input checked="" class="ms-auto kt-switch" name="check" type="checkbox"
												value="1" />
										</a>
									</li>
								</ul>
							</div>
						</li>
						<li>
							<a class="kt-dropdown-menu-link" href="https://devs.keenthemes.com">
								<i class="ki-filled ki-message-programming">
								</i>
								Dev Forum
							</a>
						</li>
						<li data-kt-dropdown="true" data-kt-dropdown-placement="right-start"
							data-kt-dropdown-trigger="hover">
							<button class="kt-dropdown-menu-toggle py-1" data-kt-dropdown-toggle="true">
								<span class="flex items-center gap-2">
									<i class="ki-filled ki-icon">
									</i>
									Language
								</span>
								<span class="ms-auto kt-badge kt-badge-stroke shrink-0">
									English
									<img alt="" class="inline-block size-3.5 rounded-full"
										src="assets/media/flags/united-states.svg" />
								</span>
							</button>
							<div class="kt-dropdown-menu w-[180px]" data-kt-dropdown-menu="true">
								<ul class="kt-dropdown-menu-sub">
									<li class="active">
										<a class="kt-dropdown-menu-link" href="?dir=ltr">
											<span class="flex items-center gap-2">
												<img alt="" class="inline-block size-4 rounded-full"
													src="assets/media/flags/united-states.svg" />
												<span class="kt-menu-title">
													English
												</span>
											</span>
											<i class="ki-solid ki-check-circle ms-auto text-green-500 text-base">
											</i>
										</a>
									</li>
									<li class="">
										<a class="kt-dropdown-menu-link" href="?dir=rtl">
											<span class="flex items-center gap-2">
												<img alt="" class="inline-block size-4 rounded-full"
													src="assets/media/flags/saudi-arabia.svg" />
												<span class="kt-menu-title">
													Arabic(Saudi)
												</span>
											</span>
										</a>
									</li>
									<li class="">
										<a class="kt-dropdown-menu-link" href="?dir=ltr">
											<span class="flex items-center gap-2">
												<img alt="" class="inline-block size-4 rounded-full"
													src="assets/media/flags/spain.svg" />
												<span class="kt-menu-title">
													Spanish
												</span>
											</span>
										</a>
									</li>
									<li class="">
										<a class="kt-dropdown-menu-link" href="?dir=ltr">
											<span class="flex items-center gap-2">
												<img alt="" class="inline-block size-4 rounded-full"
													src="assets/media/flags/germany.svg" />
												<span class="kt-menu-title">
													German
												</span>
											</span>
										</a>
									</li>
									<li class="">
										<a class="kt-dropdown-menu-link" href="?dir=ltr">
											<span class="flex items-center gap-2">
												<img alt="" class="inline-block size-4 rounded-full"
													src="assets/media/flags/japan.svg" />
												<span class="kt-menu-title">
													Japanese
												</span>
											</span>
										</a>
									</li>
								</ul>
							</div>
						</li>
						<li>
							<div class="kt-dropdown-menu-separator">
							</div>
						</li>
					</ul>
					<div class="px-2.5 pt-1.5 mb-2.5 flex flex-col gap-3.5">
						<div class="flex items-center gap-2 justify-between">
							<span class="flex items-center gap-2">
								<i class="ki-filled ki-moon text-base text-muted-foreground">
								</i>
								<span class="font-medium text-2sm">
									Dark Mode
								</span>
							</span>
							<input class="kt-switch" data-kt-theme-switch-state="dark"
								data-kt-theme-switch-toggle="true" name="check" type="checkbox" value="1" />
						</div>
						<a class="kt-btn kt-btn-outline justify-center w-full"
							href="#">
							Log out
						</a>
					</div>
				</div>
			</div>
			<!-- End of User -->
		</div>
		<!-- End of Topbar -->
	</div>
	<!-- end: container -->
</header>